// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:56:39.009Z
// Property: Delta Pointe Apartments (ID: 6767906449166892)
// Collections: 16 amenities, 6 floorplans (live), 52 photos, 41 POIs, 1 reviews, 9 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166892",
  "property_external_id": "495799",
  "property_zillow_url": "https://www.zillow.com/homedetails/1560-Waterwheel-Dr-Sacramento-CA-95833/300342787_zpid/",
  "property_apartments_url": "https://www.apartments.com/delta-pointe-apartments-sacramento-ca/drb7v1j/",
  "property_google_business_url": "https://www.google.com/maps/place/Delta+Pointe+Apartments/data=!4m2!3m1!1s0x0:0x72b3fd9a8ab7e440?sa=X&ved=2ahUKEwiIwqiDi7ySAxXnZWwGHXhYAsgQ_BJ6BAhAEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "55019388819",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495800 p0505468",
  "property_status": null,
  "property_slug": "delta-pointe-apartments",
  "property_name": "Delta Pointe Apartments",
  "property_website_url": "https://www.sacramentocaliforniaapartments.com/",
  "property_domain": "https://www.sacramentocaliforniaapartments.com/",
  "property_address": "1560 Waterwheel Drive",
  "property_full_address": "1560 Waterwheel Dr, Sacramento, CA 95833",
  "property_address_1": "1560 Waterwheel Drive",
  "property_address_2": null,
  "property_address_city": "Sacramento",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95833",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "North Sacramento",
  "property_address_latitude": "38.61009809999999",
  "property_address_longitude": "-121.4955006",
  "property_email": "deltapointe@ctlmanagement.com",
  "property_phone": "(279) 240-3952",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Felta Point in Sacramento, CA, your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans, complete with modern amenities like a fitness center, two refreshing pools, and a cozy wood-burning fireplace. Ready to elevate your lifestyle? Browse our availability and schedule a tour today!",
  "property_long_description": "Welcome to Felta Point, where modern living meets vibrant community in the heart of Sacramento, CA. Our beautifully designed apartment community offers an array of spacious floor plans, including one, two, and three-bedroom options to suit your every need. Each apartment is thoughtfully equipped with essential amenities like centralized heating and air, full-size washer and dryer, and a microwave for your convenience. Enjoy cozy evenings by the wood-burning fireplace or relax on your private enclosed courtyard or dual patios available in select homes.\n\nAt Felta Point, we believe that luxury extends beyond your front door. Dive into relaxation at our two sparkling swimming pools or recharge in our fully-equipped fitness center – complete with free Wi-Fi to keep you connected. Unwind at our spa, challenge friends on the tennis court, or gather in our inviting clubhouse, available for rentals. For our furry residents, our bark park provides the perfect space for play.\n\nYour practical needs are well-catered for with 24-hour package lockers and a garage included in select units, ensuring that convenience is always at your fingertips. \n\nDon’t miss out on the lifestyle you’ve been looking for – Felta Point is more than just a place to live; it’s a community that welcomes you home. Find your new home today! Browse our availability or schedule a tour to experience everything that Felta Point has to offer.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b5f-495b-76cf-9117-ae4b06b82573.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building with manicured lawns and trees.",
    "public_id": "019d2b5f-495b-76cf-9117-ae4b06b82573",
    "storage_key": "property/6767906449166892/019d2b5f-495b-76cf-9117-ae4b06b82573.webp",
    "width": 2560,
    "height": 1195
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "268",
  "property_year_built": "1982",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.13432835820896",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": " Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://sacramentocaliforniaapartments.securecafe.com/onlineleasing/delta-pointe-0/guestlogin",
  "property_resident_portal_url": "https://sacramentocaliforniaapartments.securecafenet.com/residentservices/delta-pointe-0/userlogin",
  "property_apply_now_url": "https://sacramentocaliforniaapartments.securecafe.com/onlineleasing/delta-pointe-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d73d0-b3f5-737b-a46f-5ff547fbd600.webp",
  "property_primary_logo_media": {
    "alt_text": "Delta Pointe Apartments logo",
    "public_id": "019d73d0-b3f5-737b-a46f-5ff547fbd600",
    "storage_key": "property/6767906449166892/019d73d0-b3f5-737b-a46f-5ff547fbd600.webp",
    "width": 576,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d73d0-b442-76fc-b659-658dac713343.webp",
  "property_secondary_logo_media": {
    "alt_text": "Delta Pointe Apartments logo.",
    "public_id": "019d73d0-b442-76fc-b659-658dac713343",
    "storage_key": "property/6767906449166892/019d73d0-b442-76fc-b659-658dac713343.webp",
    "width": 578,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019de0b2-a49d-7194-9d61-655dd148b0cf.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic graphic.",
    "public_id": "019de0b2-a49d-7194-9d61-655dd148b0cf",
    "storage_key": "property/6767906449166892/019de0b2-a49d-7194-9d61-655dd148b0cf.webp",
    "width": 576,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019de0b2-97f2-7038-a8e6-f0e9e3dd06d8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle graphic",
    "public_id": "019de0b2-97f2-7038-a8e6-f0e9e3dd06d8",
    "storage_key": "property/6767906449166892/019de0b2-97f2-7038-a8e6-f0e9e3dd06d8.webp",
    "width": 576,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "770 - 1290",
  "property_sqft_min": "770",
  "property_sqft_max": "1290",
  "property_price_range": "1830 - 3295",
  "property_price_min": "1830",
  "property_price_max": "3295",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/DeltaPointeApartments/",
  "property_instagram_url": "https://www.instagram.com/p/DTOO7uADss8/#:~:text=Our%2024%2Dhour%20fitness%20center%20has%20everything,need%20to%20reach%20your%20goals!",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9-pbouPWmoARQOS3ipr9s3I",
  "property_youtube_url": "https://m.youtube.com/watch?t=131&v=2ewHVSTxcFY",
  "property_yelp_url": "https://www.yelp.com/biz/delta-pointe-apartments-sacramento?start=20",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Felta Point",
  "property_home_romance_title": "Embrace Life and Love in Your New Community Home",
  "property_home_amenities_blurb": "Step into Felta Point, where modern living meets comfort in Sacramento. Choose from spacious one, two, or three-bedroom floor plans, each designed for your lifestyle. Enjoy our state-of-the-art fitness center, relaxing spa, and stunning swimming pools. Your pet-friendly oasis awaits, complete with garages and cozy fireplaces. Dive into your new home!",
  "property_home_floorplans_blurb": "At Felta Point in vibrant Sacramento, CA, a tapestry of unique floor plans awaits your discovery. Embrace the perfect blend of modern living and community spirit in spacious layouts designed for your comfort. Browse our available apartment homes today and unlock the ideal space that reflects your lifestyle!",
  "property_home_gallery_blurb": "At Felta Point in Sacramento, CA, every detail is designed for comfort and convenience. Choose from spacious one, two, or three-bedroom floor plans, all featuring modern amenities like a well-equipped fitness center, serene spa, and inviting swimming pools. Picture yourself enjoying your perfect home with delightful features, including wood-burning fireplaces and private courtyards!",
  "property_home_neighborhood_blurb": "At Felta Point in Sacramento, your new home is more than just a space; it’s a gateway to a vibrant community. Located near iconic spots like the California State Capitol Museum, Sacramento Zoo, and the scenic Discovery Park, life here blends urban convenience with natural beauty. Uncover the possibilities today!",
  "property_home_reviews_blurb": "At Felta Point in Sacramento, our residents rave about the vibrant atmosphere and welcoming community. One resident shares, “The staff genuinely cares, making this place feel like home.” Experience the warmth and charm for yourself—check out what our residents are saying about life at Felta Point!",
  "property_neighborhood_blurb": "At Felta Point in Sacramento, immerse yourself in a vibrant community brimming with local treasures. From the serene trails of Discovery Park to the cultural allure of the California State Capitol Museum, adventure awaits. Uncover parks, educational institutions, and unique attractions just steps from your front door. Explore what surrounds you today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Felta Point in Sacramento, CA, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans, each thoughtfully designed with modern amenities. Indulge in our fitness center, relax by the pools, or enjoy a game on the tennis court. Experience the vibrant lifestyle you deserve!",
  "property_applynow_blurb": "At Felta Point in vibrant Sacramento, CA, embrace the perfect blend of comfort and style with our range of one, two, and three-bedroom floor plans. Enjoy luxurious amenities like two sparkling swimming pools, a serene spa, and a state-of-the-art fitness center. Ready to elevate your lifestyle? Lease online today!",
  "property_contactus_blurb": "At Felta Point in Sacramento, CA, your ideal home awaits! Choose from stylish one, two, or three-bedroom floor plans that cater to your lifestyle. Have questions? Our leasing team is ready to help you find the perfect apartment. Reach out today to learn more about your future home!",
  "property_faqs_blurb": "At Felta Point in Sacramento, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your go-to resource for all things community-related. Dive right in and discover the convenience that Felta Point has to offer!",
  "property_floorplans_blurb": "At Felta Point in Sacramento, CA, your ideal home awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, each crafted to fit your lifestyle. Browse our available apartment homes now and unlock a space that resonates with your unique taste and comfort. Your dream apartment is closer than you think!",
  "property_gallery_blurb": "At Felta Point in Sacramento, CA, your ideal apartment awaits with spacious one, two, and three-bedroom floor plans. Embrace a vibrant lifestyle with our amenities, including two sparkling pools, a state-of-the-art fitness center, and a dog-friendly bark park. Picture yourself living here—scroll through our photo gallery for inspiration!",
  "property_interactivemap_blurb": "At Felta Point in Sacramento, CA, your ideal lifestyle awaits. Choose from spacious one, two, or three-bedroom apartments adorned with amenities that enhance daily living—like a relaxable spa, invigorating fitness center, and welcoming bark park. Use our interactive community map for easy access to pricing and to find your perfect home!",
  "property_pets_blurb": "At Felta Point in vibrant Sacramento, your furry companions are cherished! With a welcoming policy for indoor adult cats and dogs, plus space for small caged animals, your home will be filled with joy. Enjoy pet-friendly living with a modest monthly fee and embrace a community that loves pets just as much as you do!",
  "property_referafriend_blurb": "At Felta Point in Sacramento, CA, your ideal living space awaits—whether it’s a cozy one-bedroom, a spacious two-bedroom, or a generous three-bedroom apartment. Invite your friends to join our vibrant community and enjoy life together. Great friends make great neighbors—refer a friend today and enhance your experience!",
  "property_residentaccess_blurb": "At Felta Point in Sacramento, CA, your ideal home awaits with thoughtfully designed one-, two-, and three-bedroom floor plans. Seamlessly manage your living experience through our resident portal—pay rent, schedule maintenance, and more, all with just a few clicks. Log in and embrace convenient living today!",
  "property_reviews_blurb": "At Felta Point in Sacramento, our residents rave about the vibrant community atmosphere, saying, “It feels like home with amazing neighbors!” Join a welcoming space where comfort meets convenience. See what our residents have to say about living at our community and experience the Felta Point difference for yourself!",
  "property_created_at": "1762784863695",
  "property_scheduletour_blurb": "At Felta Point in Sacramento, CA, our thoughtfully designed one, two, and three-bedroom apartments cater to your lifestyle needs. Each home invites comfort and style. Ready to experience vibrant living? Schedule a tour and hear authentic stories from our residents about their life at Felta Point!",
  "property_thankyou_blurb": "Thank you for reaching out to Felta Point in beautiful Sacramento, CA! Our diverse floor plans—ranging from cozy one-bedrooms to spacious three-bedrooms—offer a perfect fit for every lifestyle. Stay tuned; a dedicated team member will connect with you shortly to assist you in finding your ideal home!",
  "property_virtualtours_blurb": "Welcome to Felta Point in Sacramento, CA! Dive into our vibrant community with thoughtfully designed floor plans, from one to three-bedroom apartments. Experience spacious living, modern finishes, and stunning views. Ready to find your perfect home? Take a virtual tour of our apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Felta Point",
  "property_seo_title_home": "Felta Point |  Apartments in Sacramento, CA",
  "property_seo_description_home": "Welcome to Felta Point in Sacramento, CA! Choose from spacious 1-3 bedroom apartments with stunning amenities. Your ideal home awaits—secure it today!",
  "property_seo_title_floorplans": "Floor Plans | Sacramento, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Felta Point in Sacramento, CA! Browse one, two, and three-bedroom floor plans tailored for your lifestyle. Your new adventure awaits!",
  "property_seo_title_amenities": "Amenities | Sacramento, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience Felta Point in Sacramento, CA! Enjoy modern living with a fitness center, spa, pools, bark park, and more. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Sacramento, CA",
  "property_seo_description_gallery": "Discover Felta Point in Sacramento, CA: luxurious one to three-bedroom homes with top-notch amenities and breathtaking views. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Felta Point Apartments",
  "property_seo_description_virtualtours": "Unveil the charm of Felta Point in Sacramento, CA! Take a virtual tour of our inviting one, two, and three-bedroom apartments. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Felta Point Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Felta Point in Sacramento, CA! Use our interactive map to explore spacious one to three-bedroom apartments and premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sacramento, CA",
  "property_seo_description_neighborhood": "Uncover the vibrant life around Felta Point in Sacramento, CA. Dive into local favorites and hidden gems near our one-, two-, and three-bedroom apartments!",
  "property_seo_title_contact": "Contact Us | Felta Point",
  "property_seo_description_contact": "Connect with Felta Point in Sacramento, CA! Whether you need details on our one, two, or three-bedroom floor plans, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Sacramento, CA",
  "property_seo_description_faqs": "Get answers to your questions at Felta Point in Sacramento, CA! Our FAQs cover everything from amenities to floor plans—explore what makes us home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sacramento, CA",
  "property_seo_description_reviews": "Join the Felta Point community in Sacramento! Discover why residents love their spacious homes, pools, and fitness center. ",
  "property_seo_title_applynow": "Apply Now | Apartments in Sacramento, CA",
  "property_seo_description_applynow": "Experience luxury living at Felta Point in Sacramento! Choose from spacious floor plans, enjoy top-notch amenities, and lease your dream home online today!",
  "property_seo_title_residentaccess": "Resident Access | Felta Point",
  "property_seo_description_residentaccess": "Log into Felta Point's resident portal—your hub for easy rent payments, maintenance requests, and connecting with your Sacramento community.",
  "property_seo_title_referafriend": "Refer A Friend | Felta Point",
  "property_seo_description_referafriend": "Refer a friend to Felta Point in Sacramento, CA! Great friends create a vibrant community. Share the joy of great living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Felta Point",
  "property_seo_description_scheduletour": "Experience the charm of Felta Point in Sacramento, CA! Book your tour today and step into your future home surrounded by natural beauty and vibrant amenities.",
  "property_seo_title_privacy": "Privacy Policy | Felta Point",
  "property_seo_description_privacy": "At Felta Point in Sacramento, we prioritize your privacy. Discover how we safeguard your info and view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Felta Point",
  "property_seo_description_accessibility": "At Felta Point in Sacramento, we champion digital inclusion for all residents. Discover our commitment to accessibility and a community where everyone belongs.",
  "property_seo_title_sitemap": "Sitemap | Felta Point",
  "property_seo_description_sitemap": "Navigate your way to vibrant living at Felta Point in Sacramento, CA. Uncover the essence of community and comfort. Check out our sitemap for details!",
  "property_seo_title_thankyou": "Thank You | Felta Point",
  "property_seo_description_thankyou": "Thank you for reaching out to Felta Point in Sacramento! Our team will be in touch soon to help you find your perfect apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Sacramento, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1783036158746",
  "amenities": [
    {
      "id": "ec_5f7bff5ab5f4d434aa6038cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428833",
      "title": "Fitness Center With Free Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019fbc19-37de-7708-8f03-9f5d9a6c5587.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills and stationary bikes.",
        "public_id": "019fbc19-37de-7708-8f03-9f5d9a6c5587",
        "storage_key": "property/6767906449166892/019fbc19-37de-7708-8f03-9f5d9a6c5587.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "fitness center cardio equipment at Delta Pointe Apartments, Sacramento,fitness center and equipment at Delta Pointe Apartments, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e3b164ed9b238dda272e33a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428831",
      "title": "2 Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2ad3-777a-a5ca-c8ae563fa70a.webp",
      "amenity_image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and lush green landscaping on a sunny day.",
        "public_id": "019d4ccd-2ad3-777a-a5ca-c8ae563fa70a",
        "storage_key": "property/6767906449166892/019d4ccd-2ad3-777a-a5ca-c8ae563fa70a.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool side view at Delta Pointe Apartments, CA 95833,swimming pool with lounge chairs at Delta Pointe Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38b277e018bc7faa2211fa18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428837",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2c08-76b6-aafb-2e31f37d5898.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and spa area with lounge chairs and umbrellas.",
        "public_id": "019d4ccd-2c08-76b6-aafb-2e31f37d5898",
        "storage_key": "property/6767906449166892/019d4ccd-2c08-76b6-aafb-2e31f37d5898.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool and spa at Delta Pointe Apartments, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d00d0478796997cdad05bd51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428839",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4981-0c10-71ed-95ea-452b522c9af1.webp",
      "amenity_image_media": {
        "alt_text": "Tennis courts with green and red surfaces surrounded by a chain-link fence and lush landscaping.",
        "public_id": "019d4981-0c10-71ed-95ea-452b522c9af1",
        "storage_key": "property/6767906449166892/019d4981-0c10-71ed-95ea-452b522c9af1.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "sports court at Delta Pointe Apartments, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd41bddc6ebeaf5bb8b75406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "86393158",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-e632-773d-8cc1-d2e782bf0d55.webp",
      "amenity_image_media": {
        "alt_text": "Package lockers with a digital screen.",
        "public_id": "019d4980-e632-773d-8cc1-d2e782bf0d55",
        "storage_key": "property/6767906449166892/019d4980-e632-773d-8cc1-d2e782bf0d55.webp",
        "width": 1632,
        "height": 1224
      },
      "amenity_image_alt_text": "Delta Pointe 24 Hour Package Lockers at Delta Pointe Apartments, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16a6ae2620126ea0dea6da3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "121989284",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d59149c1c26bb52f39c6ac06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "86393156",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-f445-7367-bedb-1405ec092a64.webp",
      "amenity_image_media": {
        "alt_text": "Spacious lounge area with a fireplace, seating, and artwork.",
        "public_id": "019d4980-f445-7367-bedb-1405ec092a64",
        "storage_key": "property/6767906449166892/019d4980-f445-7367-bedb-1405ec092a64.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "clubhouse interior lounge at Delta Pointe Apartments, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8fc309c8c927512c1f861c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "82390159",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e0ab8892f152c7f7a2d97a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "82390160",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e71ee61b61014f2d7ee0d908",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "86393167",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3042d132b216fa6cb6f46639",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "86393168",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d087f9c7490070066f24f18a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428842",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-929f-70d5-8ac3-dd37e4566c66.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer with a shelving unit above.",
        "public_id": "019d42a5-929f-70d5-8ac3-dd37e4566c66",
        "storage_key": "property/6767906449166892/019d42a5-929f-70d5-8ac3-dd37e4566c66.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Washer & Dryer at Delta Pointe Apartments, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f3421a25ee90687e3091003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428841",
      "title": "Centralized Heating & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6d014ad646387e8ec80df2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428844",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d496e-6fbe-743b-9ca6-e29e8fa1b168.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, gray armchair, and tufted ottoman.",
        "public_id": "019d496e-6fbe-743b-9ca6-e29e8fa1b168",
        "storage_key": "property/6767906449166892/019d496e-6fbe-743b-9ca6-e29e8fa1b168.webp",
        "width": 3072,
        "height": 2039
      },
      "amenity_image_alt_text": "Delta Pointe model living room and fireplace,Delta Pointe Trimaran 3x2 vacant living room with fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cf7636ba37d0c3a1889890f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "80428843",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-4486-773b-9f47-997b589b1d7b.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d1bf9-4486-773b-9f47-997b589b1d7b",
        "storage_key": "property/6767906449166892/019d1bf9-4486-773b-9f47-997b589b1d7b.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Upgraded Model Kitchen at Delta Pointe Apartments, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03b42af005504e88186f0423",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "yardi",
      "external_id": "87310414",
      "title": "Garage Included - In Most Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-5ea8-7597-bcd2-1fe2c87d3ab5.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and mature trees.",
        "public_id": "019d4980-5ea8-7597-bcd2-1fe2c87d3ab5",
        "storage_key": "property/6767906449166892/019d4980-5ea8-7597-bcd2-1fe2c87d3ab5.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "building exteriors and garages at Delta Pointe Apartments, Sacramento, California 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_92b1249201ff333686b5ee44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-6d93-7492-a215-fa63378ec1e7.webp",
      "image_media": {
        "alt_text": "Delta Pointe Apartments monument sign with 'NOW LEASING' flags.",
        "public_id": "019d42a5-6d93-7492-a215-fa63378ec1e7",
        "storage_key": "property/6767906449166892/019d42a5-6d93-7492-a215-fa63378ec1e7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Delta Pointe Apartments, a premier residential community. Check out our amenities and find your perfect home.",
      "link": "false",
      "alt_text": "Delta Pointe Apartments monument sign with 'NOW LEASING' flags.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Delta Pointe Apartments_ Apartments_Sacramento_California  (11).jpg"
    },
    {
      "id": "ec_15a9e8eb60be2064b0661df1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-4486-773b-9f47-997b589b1d7b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d1bf9-4486-773b-9f47-997b589b1d7b",
        "storage_key": "property/6767906449166892/019d1bf9-4486-773b-9f47-997b589b1d7b.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek dark wood cabinetry, modern black appliances including a microwave and stove, and elegant granite countertops. Perfect for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelKitchen01.jpg"
    },
    {
      "id": "ec_39bc21c78c35493ac1635bac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-8f7d-7614-ae8c-a80c26b77f95.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with dark wood cabinets and granite countertops.",
        "public_id": "019d42a5-8f7d-7614-ae8c-a80c26b77f95",
        "storage_key": "property/6767906449166892/019d42a5-8f7d-7614-ae8c-a80c26b77f95.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, adjacent to a fully equipped kitchen with modern appliances and ample counter space.",
      "link": "false",
      "alt_text": "Dining area and kitchen with dark wood cabinets and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelDiningRoom.jpg"
    },
    {
      "id": "ec_541ace10c5ee66e9961cc2a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-44e8-7011-ba01-8b428730d933.webp",
      "image_media": {
        "alt_text": "Cozy living and dining area with a sofa, dining table, and plants.",
        "public_id": "019d1bf9-44e8-7011-ba01-8b428730d933",
        "storage_key": "property/6767906449166892/019d1bf9-44e8-7011-ba01-8b428730d933.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living and dining area. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Cozy living and dining area with a sofa, dining table, and plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelLivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_35ac485baaa60c6d923c639a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-480b-7579-b6e2-4eb3520abc12.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area.",
        "public_id": "019d1bf9-480b-7579-b6e2-4eb3520abc12",
        "storage_key": "property/6767906449166892/019d1bf9-480b-7579-b6e2-4eb3520abc12.webp",
        "width": 1200,
        "height": 794
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa and elegant dining set, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelLivingRoom02.jpg"
    },
    {
      "id": "ec_e0a487d1693c7fff3cb75a3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d496e-6fbe-743b-9ca6-e29e8fa1b168.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, gray armchair, and tufted ottoman.",
        "public_id": "019d496e-6fbe-743b-9ca6-e29e8fa1b168",
        "storage_key": "property/6767906449166892/019d496e-6fbe-743b-9ca6-e29e8fa1b168.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a comfortable armchair, and a stylish tufted ottoman, perfect for relaxing.",
      "link": "false",
      "alt_text": "Living room with a fireplace, gray armchair, and tufted ottoman.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelLivingRoomandFireplace.jpg"
    },
    {
      "id": "ec_e88b7f956800098325c48db1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d496e-6fb7-743f-9fea-4e8cb2f60e87.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, gray armchair, fireplace, and decor.",
        "public_id": "019d496e-6fb7-743f-9fea-4e8cb2f60e87",
        "storage_key": "property/6767906449166892/019d496e-6fb7-743f-9fea-4e8cb2f60e87.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white sofa, elegant armchair, and a decorative fireplace, perfect for relaxing.",
      "link": "false",
      "alt_text": "Living room with a white sofa, gray armchair, fireplace, and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelLivingRoomSideView.jpg"
    },
    {
      "id": "ec_8d30122b86b1a4e0e7a9463c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-44d9-731a-86c1-7f43cf268f0f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and plant.",
        "public_id": "019d1bf9-44d9-731a-86c1-7f43cf268f0f",
        "storage_key": "property/6767906449166892/019d1bf9-44d9-731a-86c1-7f43cf268f0f.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with decorative pillows, a stylish nightstand, and a large potted plant for a touch of nature.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelMasterBedroom.jpg"
    },
    {
      "id": "ec_6c74d87a2db55d9b565f4c5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-9049-7011-8a75-6d4e9503999e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and mirror.",
        "public_id": "019d42a5-9049-7011-8a75-6d4e9503999e",
        "storage_key": "property/6767906449166892/019d42a5-9049-7011-8a75-6d4e9503999e.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a wooden dresser with a lamp and decor, and a large mirror.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_fbc4c9f037df435d2d39e620",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d1bf9-4480-713b-94c9-8762f49da6a7.webp",
      "image_media": {
        "alt_text": "Closet and bathroom with shower and toilet",
        "public_id": "019d1bf9-4480-713b-94c9-8762f49da6a7",
        "storage_key": "property/6767906449166892/019d1bf9-4480-713b-94c9-8762f49da6a7.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet and a full bathroom with a shower/tub combination.",
      "link": "false",
      "alt_text": "Closet and bathroom with shower and toilet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelMasterClosetBathroom.jpg"
    },
    {
      "id": "ec_7ce788bf867598231345f422",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-8ec2-75a4-af52-8ef7b3f892d2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, granite countertops, and a bathtub with a shower curtain.",
        "public_id": "019d42a5-8ec2-75a4-af52-8ef7b3f892d2",
        "storage_key": "property/6767906449166892/019d42a5-8ec2-75a4-af52-8ef7b3f892d2.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a spacious vanity with granite countertops, a large mirror, and a separate bathtub and toilet area for your convenience.",
      "link": "false",
      "alt_text": "Modern bathroom with a white vanity, granite countertops, and a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelBathroom01.jpg"
    },
    {
      "id": "ec_73b129fd7c07fd7291e859b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-91d5-7179-9026-bf34a22a4b28.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, toilet, and vanity.",
        "public_id": "019d42a5-91d5-7179-9026-bf34a22a4b28",
        "storage_key": "property/6767906449166892/019d42a5-91d5-7179-9026-bf34a22a4b28.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a bathtub with shower curtain, toilet, and granite vanity with sink.",
      "link": "false",
      "alt_text": "Modern bathroom with bathtub, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelBathroom02.jpg"
    },
    {
      "id": "ec_5582fe3036bb9e2890b75d46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d42a5-929f-70d5-8ac3-dd37e4566c66.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a shelving unit above.",
        "public_id": "019d42a5-929f-70d5-8ac3-dd37e4566c66",
        "storage_key": "property/6767906449166892/019d42a5-929f-70d5-8ac3-dd37e4566c66.webp",
        "width": 1200,
        "height": 798
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer available for residents, with a shelf for storage.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with a shelving unit above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ModelLaundry.jpg"
    },
    {
      "id": "ec_b79def7ef7873acf8540caf0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-57a3-751c-a449-b54b12535d6d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with landscaping and a dry creek bed.",
        "public_id": "019d4980-57a3-751c-a449-b54b12535d6d",
        "storage_key": "property/6767906449166892/019d4980-57a3-751c-a449-b54b12535d6d.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Experience comfortable living in our well-maintained apartment community, featuring beautiful exteriors and lush green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with landscaping and a dry creek bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_BuildingExteriorMailStation.jpg"
    },
    {
      "id": "ec_47711e7e097225690ad3204b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-9ae5-7214-b134-f0df1c579d90.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with green lawn and trees.",
        "public_id": "019d4980-9ae5-7214-b134-f0df1c579d90",
        "storage_key": "property/6767906449166892/019d4980-9ae5-7214-b134-f0df1c579d90.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully maintained apartment building exterior with lush green landscaping and mature trees. Enjoy comfortable living in this serene community.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with green lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_BuildingExteriorGreenSpace.jpg"
    },
    {
      "id": "ec_4aa654a2734535594ce9e94e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-5ea8-7597-bcd2-1fe2c87d3ab5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and mature trees.",
        "public_id": "019d4980-5ea8-7597-bcd2-1fe2c87d3ab5",
        "storage_key": "property/6767906449166892/019d4980-5ea8-7597-bcd2-1fe2c87d3ab5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Facade of apartment buildings featuring garages and lush green trees, offering a glimpse of the community's outdoor aesthetics.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with garages and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_BuildingExteriorGarages.jpg"
    },
    {
      "id": "ec_b961bdf96cb94c64d75921c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-61c0-70ec-a619-4d93747403cf.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with landscaping and a dry creek bed.",
        "public_id": "019d4980-61c0-70ec-a619-4d93747403cf",
        "storage_key": "property/6767906449166892/019d4980-61c0-70ec-a619-4d93747403cf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment buildings with lush landscaping and a dry creek bed, creating a serene and inviting community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with landscaping and a dry creek bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ClubhouseExterior.jpg"
    },
    {
      "id": "ec_bc6ed6513fee028638434380",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-f445-7367-bedb-1405ec092a64.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with a fireplace, seating, and artwork.",
        "public_id": "019d4980-f445-7367-bedb-1405ec092a64",
        "storage_key": "property/6767906449166892/019d4980-f445-7367-bedb-1405ec092a64.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lounge area, featuring a cozy fireplace and ample seating for socializing or quiet enjoyment.",
      "link": "false",
      "alt_text": "Spacious lounge area with a fireplace, seating, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_ClubhouseInteriorLounge.jpg"
    },
    {
      "id": "ec_af4c8ac38de08abae86021a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-e3dd-74a8-8c48-06cb2192cf1c.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and mirrors.",
        "public_id": "019d4980-e3dd-74a8-8c48-06cb2192cf1c",
        "storage_key": "property/6767906449166892/019d4980-e3dd-74a8-8c48-06cb2192cf1c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines and weight training equipment. Maintain your workout routine with our convenient on-site gym.",
      "link": "false",
      "alt_text": "Gym with cardio machines, weight machines, and mirrors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_FitnessCenterEquipment.jpg"
    },
    {
      "id": "ec_7068e2864bebbb9a44acbe6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4980-e632-773d-8cc1-d2e782bf0d55.webp",
      "image_media": {
        "alt_text": "Package lockers with a digital screen.",
        "public_id": "019d4980-e632-773d-8cc1-d2e782bf0d55",
        "storage_key": "property/6767906449166892/019d4980-e632-773d-8cc1-d2e782bf0d55.webp",
        "width": 1632,
        "height": 1224
      },
      "title": "Community",
      "description": "Modern package lockers provide secure and convenient package delivery for residents.",
      "link": "false",
      "alt_text": "Package lockers with a digital screen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_24HourPackageLockers(1).jpeg"
    },
    {
      "id": "ec_fcd3ac0412c626bc9942d75f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4981-0c10-71ed-95ea-452b522c9af1.webp",
      "image_media": {
        "alt_text": "Tennis courts with green and red surfaces surrounded by a chain-link fence and lush landscaping.",
        "public_id": "019d4981-0c10-71ed-95ea-452b522c9af1",
        "storage_key": "property/6767906449166892/019d4981-0c10-71ed-95ea-452b522c9af1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our well-maintained tennis courts, perfect for staying active and enjoying the outdoors within our beautiful community.",
      "link": "false",
      "alt_text": "Tennis courts with green and red surfaces surrounded by a chain-link fence and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_SportsCourt.jpg"
    },
    {
      "id": "ec_1c9ec97c3087f08018072e94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4981-1445-779d-b8fd-7b110e27e5b7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and tennis court at apartment complex",
        "public_id": "019d4981-1445-779d-b8fd-7b110e27e5b7",
        "storage_key": "property/6767906449166892/019d4981-1445-779d-b8fd-7b110e27e5b7.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the community pool or a game on the tennis court.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and tennis court at apartment complex",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_SwimmingPoolExterior.jpg"
    },
    {
      "id": "ec_26785a30bd7a960e7805116d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2c08-76b6-aafb-2e31f37d5898.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and spa area with lounge chairs and umbrellas.",
        "public_id": "019d4ccd-2c08-76b6-aafb-2e31f37d5898",
        "storage_key": "property/6767906449166892/019d4ccd-2c08-76b6-aafb-2e31f37d5898.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool or unwind in the soothing spa. Plenty of lounge chairs and umbrellas available for your comfort.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and spa area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_SwimmingPoolSpa.jpg"
    },
    {
      "id": "ec_74ad057e277a953078ef3dc6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2ad3-777a-a5ca-c8ae563fa70a.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and lush green landscaping on a sunny day.",
        "public_id": "019d4ccd-2ad3-777a-a5ca-c8ae563fa70a",
        "storage_key": "property/6767906449166892/019d4ccd-2ad3-777a-a5ca-c8ae563fa70a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by resort-style landscaping and ample seating for relaxation.",
      "link": "false",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and lush green landscaping on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_SwimmingPoolSideView.jpg"
    },
    {
      "id": "ec_39bff5e8d43f1f044280be24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2b9b-77be-ab2a-07babb7a9869.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d4ccd-2b9b-77be-ab2a-07babb7a9869",
        "storage_key": "property/6767906449166892/019d4ccd-2b9b-77be-ab2a-07babb7a9869.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_SwimmingPoolLounges.jpg"
    },
    {
      "id": "ec_17a18c5ca9c18b15035bfc72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-2952-755e-906c-5535d1a68861.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, a double sink, and black appliances including a microwave, stove, and refrigerator.",
        "public_id": "019d4ccd-2952-755e-906c-5535d1a68861",
        "storage_key": "property/6767906449166892/019d4ccd-2952-755e-906c-5535d1a68861.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, elegant granite countertops, a convenient double sink, and a full suite of modern black appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, a double sink, and black appliances including a microwave, stove, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantKitchen.jpg"
    },
    {
      "id": "ec_859fb93b1b156ef03f989ccd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-29ad-717b-a334-2f7b8ba04e81.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d4ccd-29ad-717b-a334-2f7b8ba04e81",
        "storage_key": "property/6767906449166892/019d4ccd-29ad-717b-a334-2f7b8ba04e81.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, granite countertops, a double-basin sink, and a full suite of black appliances, including a refrigerator, range, and microwave.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel sink, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantKitchenBar.jpg"
    },
    {
      "id": "ec_50733f6f3942b9ea93adca34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-7525-734a-9e20-472c43e65ccb.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment.",
        "public_id": "019d4ccd-7525-734a-9e20-472c43e65ccb",
        "storage_key": "property/6767906449166892/019d4ccd-7525-734a-9e20-472c43e65ccb.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room with vaulted ceilings, a ceiling fan, and a pass-through to the kitchen. The kitchen features dark wood cabinets and a refrigerator.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantKitchenEntryView.jpg"
    },
    {
      "id": "ec_c69a298a885d1c795c08a8e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-87d5-74f1-bfc4-74cb5a4608a8.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceiling, built-in bookshelves, fireplace, and sliding glass door to patio.",
        "public_id": "019d4ccd-87d5-74f1-bfc4-74cb5a4608a8",
        "storage_key": "property/6767906449166892/019d4ccd-87d5-74f1-bfc4-74cb5a4608a8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring vaulted ceilings, elegant built-in bookshelves, a cozy fireplace, and a sliding glass door that opens to a private patio. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with vaulted ceiling, built-in bookshelves, fireplace, and sliding glass door to patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantLivingRoom.jpg"
    },
    {
      "id": "ec_d15bbc545d861eac3c2022a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-6f36-77c9-834a-6cef8c7784b6.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and ceiling fan.",
        "public_id": "019d4ccd-6f36-77c9-834a-6cef8c7784b6",
        "storage_key": "property/6767906449166892/019d4ccd-6f36-77c9-834a-6cef8c7784b6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a warm fireplace and a vaulted ceiling with a ceiling fan, perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Spacious living room with a fireplace and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantLivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_05787a90d9898ecca7719dc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-7196-71ac-933a-e07fd991d19f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass door to balcony.",
        "public_id": "019d4ccd-7196-71ac-933a-e07fd991d19f",
        "storage_key": "property/6767906449166892/019d4ccd-7196-71ac-933a-e07fd991d19f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, plush carpeting, and a sliding glass door leading to a private balcony. Perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with fireplace and sliding glass door to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantFireplaceDeck.jpg"
    },
    {
      "id": "ec_f3c4a4726c030a5d590121ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-9015-729c-9023-8fbbe7fd354b.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and an ensuite bathroom entrance.",
        "public_id": "019d4ccd-9015-729c-9023-8fbbe7fd354b",
        "storage_key": "property/6767906449166892/019d4ccd-9015-729c-9023-8fbbe7fd354b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring large mirrored closet doors and access to a well-appointed ensuite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and an ensuite bathroom entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantPrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_b26a132ea4f5fce0babcb9c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-be9e-778a-be39-6f7124f7e307.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and a large window with vertical blinds.",
        "public_id": "019d4ccd-be9e-778a-be39-6f7124f7e307",
        "storage_key": "property/6767906449166892/019d4ccd-be9e-778a-be39-6f7124f7e307.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious and unfurnished bedroom, perfect for personalizing your new apartment. Features neutral carpeting and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Empty bedroom with neutral carpet and a large window with vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantPrimaryBedroom.jpg"
    },
    {
      "id": "ec_3ea55805b91e715ae0da54a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-d39c-74cc-9cb8-93cdbc58c0c4.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and plush carpet.",
        "public_id": "019d4ccd-d39c-74cc-9cb8-93cdbc58c0c4",
        "storage_key": "property/6767906449166892/019d4ccd-d39c-74cc-9cb8-93cdbc58c0c4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet and soft, neutral carpeting. An adjacent hallway is visible through the open doorway.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and plush carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Schooner2x2VacantSecondBedroom.jpg"
    },
    {
      "id": "ec_d66b9589a3f2217ed4e628b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-e5f1-74a9-a80c-24c7e34f4a60.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel sink.",
        "public_id": "019d4ccd-e5f1-74a9-a80c-24c7e34f4a60",
        "storage_key": "property/6767906449166892/019d4ccd-e5f1-74a9-a80c-24c7e34f4a60.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, elegant granite countertops, a double basin sink, and essential appliances for a comfortable cooking experience.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantKitchen.jpg"
    },
    {
      "id": "ec_44480bf14b32ce7b4e98d7f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-d538-729e-a4f5-453ef1e092aa.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with dark wood cabinets, granite countertops, and a ceiling fan.",
        "public_id": "019d4ccd-d538-729e-a4f5-453ef1e092aa",
        "storage_key": "property/6767906449166892/019d4ccd-d538-729e-a4f5-453ef1e092aa.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area featuring dark wood cabinetry, granite countertops, and a modern ceiling fan for comfort. Perfect for everyday living.",
      "link": "false",
      "alt_text": "Kitchen and dining area with dark wood cabinets, granite countertops, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_0672c164ff66dfdfd69bad09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-fdcf-75dd-a5c6-a4726cfdcc08.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and entrance, adjacent to kitchen with dark wood cabinets and black refrigerator.",
        "public_id": "019d4ccd-fdcf-75dd-a5c6-a4726cfdcc08",
        "storage_key": "property/6767906449166892/019d4ccd-fdcf-75dd-a5c6-a4726cfdcc08.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a fireplace and ample natural light, flowing into a modern kitchen equipped with dark wood cabinetry and essential appliances.",
      "link": "false",
      "alt_text": "Living room with fireplace and entrance, adjacent to kitchen with dark wood cabinets and black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantKitchenLivingRoom.jpg"
    },
    {
      "id": "ec_fd25e2c44e9873b4ee35e350",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccd-ee92-756d-b4d7-cc070d6ef559.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceilings and a fireplace.",
        "public_id": "019d4ccd-ee92-756d-b4d7-cc070d6ef559",
        "storage_key": "property/6767906449166892/019d4ccd-ee92-756d-b4d7-cc070d6ef559.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy cozy evenings by the fireplace in this spacious living room, featuring vaulted ceilings and ample natural light.",
      "link": "false",
      "alt_text": "Spacious living room with vaulted ceilings and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_fa233e267d56de7962399c40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-30ff-7478-98e5-04c911a91e04.webp",
      "image_media": {
        "alt_text": "Spacious carpeted living area with a view of the bathroom vanity.",
        "public_id": "019d4cce-30ff-7478-98e5-04c911a91e04",
        "storage_key": "property/6767906449166892/019d4cce-30ff-7478-98e5-04c911a91e04.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy the generous living space in this apartment, perfect for relaxing or entertaining. The open layout provides a seamless flow into the well-appointed bathroom.",
      "link": "false",
      "alt_text": "Spacious carpeted living area with a view of the bathroom vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantPrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_dcb3eca4c6e27e32330f22e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-5bb5-710e-aace-8f196f06549e.webp",
      "image_media": {
        "alt_text": "Empty living room with beige carpet and a sliding glass door.",
        "public_id": "019d4cce-5bb5-710e-aace-8f196f06549e",
        "storage_key": "property/6767906449166892/019d4cce-5bb5-710e-aace-8f196f06549e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral carpeting and ample natural light from the sliding glass door, perfect for creating your own personalized space.",
      "link": "false",
      "alt_text": "Empty living room with beige carpet and a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantPrimaryBedroomDeck.jpg"
    },
    {
      "id": "ec_d530babba2c8b0d4db20ee20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-4742-76dc-8061-34ed6cb86103.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves",
        "public_id": "019d4cce-4742-76dc-8061-34ed6cb86103",
        "storage_key": "property/6767906449166892/019d4cce-4742-76dc-8061-34ed6cb86103.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in shelving, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with shelves",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantPrimaryBedroomWalkInCloset.jpg"
    },
    {
      "id": "ec_063ed6a3ee44d158264d48ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-2d31-73cf-889e-ffbc738f747f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, mirrored closet doors, and vertical blinds on the window.",
        "public_id": "019d4cce-2d31-73cf-889e-ffbc738f747f",
        "storage_key": "property/6767906449166892/019d4cce-2d31-73cf-889e-ffbc738f747f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a large mirrored closet, and ample natural light from the window with vertical blinds.",
      "link": "false",
      "alt_text": "Empty bedroom with carpet, mirrored closet doors, and vertical blinds on the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantSecondBedroom.jpg"
    },
    {
      "id": "ec_bc806da3c13cdafe20b60b40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-4b82-752c-a2c2-03dfb93869df.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, sliding closet door, and a window with blinds.",
        "public_id": "019d4cce-4b82-752c-a2c2-03dfb93869df",
        "storage_key": "property/6767906449166892/019d4cce-4b82-752c-a2c2-03dfb93869df.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring neutral carpet, a spacious closet with sliding doors, and a bright window with vertical blinds for privacy.",
      "link": "false",
      "alt_text": "Bedroom with carpet, sliding closet door, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Trimaran3x2VacantThirdBedroom.jpg"
    },
    {
      "id": "ec_e85a0f7c07148f247fed8089",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-72b4-703e-b8c7-d5dca5608b68.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d4cce-72b4-703e-b8c7-d5dca5608b68",
        "storage_key": "property/6767906449166892/019d4cce-72b4-703e-b8c7-d5dca5608b68.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Explore our spacious kitchens featuring dark wood cabinetry, sleek granite countertops, and modern black appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel sink, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantKitchen.jpg"
    },
    {
      "id": "ec_3a66477fcf8f87722c49303c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-846c-736a-b31e-ad2e3d4fef9e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d4cce-846c-736a-b31e-ad2e3d4fef9e",
        "storage_key": "property/6767906449166892/019d4cce-846c-736a-b31e-ad2e3d4fef9e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Experience the convenience and style of this modern kitchen, featuring ample cabinet space, granite countertops, and a full suite of appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantKitchenBar.jpg"
    },
    {
      "id": "ec_449f947b148f2e61eca4fa1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-9622-751f-9bcd-58adafcd8a69.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment.",
        "public_id": "019d4cce-9622-751f-9bcd-58adafcd8a69",
        "storage_key": "property/6767906449166892/019d4cce-9622-751f-9bcd-58adafcd8a69.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpet and a view into the kitchen. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantLivingRoom.jpg"
    },
    {
      "id": "ec_e029633086fa71c6d9d2e672",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-ae04-76aa-a0b1-7b04695bbac5.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceiling, ceiling fan, fireplace, and large windows.",
        "public_id": "019d4cce-ae04-76aa-a0b1-7b04695bbac5",
        "storage_key": "property/6767906449166892/019d4cce-ae04-76aa-a0b1-7b04695bbac5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room with vaulted ceilings, a ceiling fan, and a cozy fireplace. Large windows flood the space with natural light.",
      "link": "false",
      "alt_text": "Living room with vaulted ceiling, ceiling fan, fireplace, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_8da0aadf16befe9185ea7030",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-af2a-7135-ad0d-7c25d6dd84fe.webp",
      "image_media": {
        "alt_text": "Hallway with dark wood cabinets and speckled countertop, leading to a bedroom.",
        "public_id": "019d4cce-af2a-7135-ad0d-7c25d6dd84fe",
        "storage_key": "property/6767906449166892/019d4cce-af2a-7135-ad0d-7c25d6dd84fe.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Ample storage and counter space in this hallway, perfect for a home office or extra kitchen prep area. The carpeted hallway leads to a well-lit bedroom.",
      "link": "false",
      "alt_text": "Hallway with dark wood cabinets and speckled countertop, leading to a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantHallwayStorage.jpg"
    },
    {
      "id": "ec_115206ac21ce8ab58a83a511",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-c69c-7519-925f-a3ed72fc5b6b.webp",
      "image_media": {
        "alt_text": "Empty room with sliding glass door and vertical blinds.",
        "public_id": "019d4cce-c69c-7519-925f-a3ed72fc5b6b",
        "storage_key": "property/6767906449166892/019d4cce-c69c-7519-925f-a3ed72fc5b6b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious room with plush carpeting and a sliding glass door leading to an outdoor space.",
      "link": "false",
      "alt_text": "Empty room with sliding glass door and vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantPrimaryBedroomDeck.jpg"
    },
    {
      "id": "ec_8e10da4f57ddef6609e22628",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-ca7f-769c-bc11-1479d0de2b47.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rods.",
        "public_id": "019d4cce-ca7f-769c-bc11-1479d0de2b47",
        "storage_key": "property/6767906449166892/019d4cce-ca7f-769c-bc11-1479d0de2b47.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet offering ample storage with built-in shelves and clothing rods.",
      "link": "false",
      "alt_text": "Empty walk-in closet with shelves and hanging rods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantPrimaryBedroomWalkInCloset.jpg"
    },
    {
      "id": "ec_a26bafa0d271caf37c2baaec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4cce-c432-7469-940b-694e5073e237.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and blinds on the window.",
        "public_id": "019d4cce-c432-7469-940b-694e5073e237",
        "storage_key": "property/6767906449166892/019d4cce-c432-7469-940b-694e5073e237.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet and a window with vertical blinds, offering a bright and airy feel.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and blinds on the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantSecondBedroom.jpg"
    },
    {
      "id": "ec_b6751d29cd3e5440af25bb40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d4ccf-0527-702f-b0e5-4cad54636c0c.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and entry to bathroom",
        "public_id": "019d4ccf-0527-702f-b0e5-4cad54636c0c",
        "storage_key": "property/6767906449166892/019d4ccf-0527-702f-b0e5-4cad54636c0c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting and a large mirrored closet, with convenient access to the en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and entry to bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/DeltaPointe_Sacramento_CA_Windjammer3x2VacantThirdBedroom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ce19d2d5-f5d6-4d4e-8234-723c7590e255",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2001 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious Double Doubles, animal fries, and milkshakes. They highlight the fresh food, fast service, and friendly staff. They also like the good value and efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-d281-730f-99ce-0ff66c0f8468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d281-730f-99ce-0ff66c0f8468",
        "storage_key": "property/6767906449166892/019d08ad-d281-730f-99ce-0ff66c0f8468.webp",
        "width": 1102,
        "height": 1280
      },
      "poi_business_url": "https://locations.in-n-out.com/276",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866440018724358803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.5980167",
      "poi_longitude": "-121.4194193",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e22-743e-94f4-41bbf421897b",
        "storage_key": "property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6ToLSPamoARk4rP3GkRiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_9db2ea20-9c9a-4656-a469-7c5884f5ef6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2101 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers delicious chicken sandwiches, salads, and shakes. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-d281-730f-99ce-097406bd4286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d281-730f-99ce-097406bd4286",
        "storage_key": "property/6767906449166892/019d08ad-d281-730f-99ce-097406bd4286.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/arden-fair?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15156801471129607094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.5987882",
      "poi_longitude": "-121.4174906",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-922-2814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e22-743e-94f4-41bbf421897b",
        "storage_key": "property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Sz6ViPamoARtlvMQaLGV9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2adb405c-1d8c-4eda-9121-6f323fe84763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Tower Café",
      "poi_type": "Restaurants",
      "poi_address": "1518 Broadway, Sacramento, CA 95818, USA",
      "poi_short_description": "Quirky cafe serving an eclectic array of grub, from classic breakfasts to Asian and Spanish mains.",
      "poi_long_description": "People say this restaurant serves delicious French toast, Thai steak and eggs, and salads. They highlight the large portions, diverse menu, and beautiful outdoor seating area with fountains and lush greenery. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-d2bf-75ff-a332-c0809319090d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d2bf-75ff-a332-c0809319090d",
        "storage_key": "property/6767906449166892/019d08ad-d2bf-75ff-a332-c0809319090d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.towercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467647007537499128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tower-caf",
      "poi_latitude": "38.5616745",
      "poi_longitude": "-121.4935217",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-441-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e22-743e-94f4-41bbf421897b",
        "storage_key": "property/6767906449166892/019d08ad-7e22-743e-94f4-41bbf421897b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4Wmdx7RmoAR-Asw4meMafI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_49b9ed7f-3f27-4f59-b5cc-b8513bca03ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Drake's: The Barn",
      "poi_type": "Restaurants",
      "poi_address": "985 Riverfront St, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor gathering place with a beer garden, pizzeria & 3 stages hosting DJs & live music shows.",
      "poi_long_description": "People say this beer garden offers a great selection of beers, delicious pizzas, and burgers. They highlight the fun, energetic, and lively atmosphere, and the spacious outdoor seating with fire pits. They also like that it's dog-friendly and family-friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-d2bf-75ff-a332-c4bbe314c6b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d2bf-75ff-a332-c4bbe314c6b8",
        "storage_key": "property/6767906449166892/019d08ad-d2bf-75ff-a332-c4bbe314c6b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://drinkdrakes.com/places/the-barn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212264906490894141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "drakes-the-barn",
      "poi_latitude": "38.574851",
      "poi_longitude": "-121.514729",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-20b1-70f5-b2ee-489eadcdef16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-20b1-70f5-b2ee-489eadcdef16",
        "storage_key": "property/6767906449166892/019d08ae-20b1-70f5-b2ee-489eadcdef16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzOrD0rRmoARPdc7a534dDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_db865971-c73c-4ae9-9610-500d27dcef43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Urban Roots Brewery & Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1322 V St, Sacramento, CA 95818, USA",
      "poi_short_description": "Stylish indoor-outdoor joint serving a wide variety of housemade beers alongside hearty BBQ fare.",
      "poi_long_description": "People say this brewpub serves delicious brisket, burnt ends, and BBQ turkey, and offers a variety of tasty sides. They highlight the generous portions, the self-serve BBQ sauce bar with three different sauces, and the friendly staff. They also like the fun, laid-back atmosphere, with both indoor and outdoor seating, and the extensive selection of craft beers and ciders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-da9c-7679-97f5-29e90d036d75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-da9c-7679-97f5-29e90d036d75",
        "storage_key": "property/6767906449166892/019d08ad-da9c-7679-97f5-29e90d036d75.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.urbanrootsbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=322330605051558123&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-roots-brewery--smokehouse",
      "poi_latitude": "38.5655783",
      "poi_longitude": "-121.4941211",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-706-3741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-20b1-70f5-b2ee-489eadcdef16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-20b1-70f5-b2ee-489eadcdef16",
        "storage_key": "property/6767906449166892/019d08ae-20b1-70f5-b2ee-489eadcdef16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6W_gh_RmoAR67hVPvoleQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_b1a70a4b-b783-443b-bf77-d4d519157eff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Arden Fair",
      "poi_type": "Shopping & Retail",
      "poi_address": "1689 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Bright, spacious mall featuring 150+ shops, a food court with fast food & full-service restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, shoes, and tech, as well as a large food court with diverse options. They also highlight the clean and well-maintained environment, and the presence of security.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-dad7-7691-9f0f-efd7fd13ac22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dad7-7691-9f0f-efd7fd13ac22",
        "storage_key": "property/6767906449166892/019d08ad-dad7-7691-9f0f-efd7fd13ac22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ardenfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499193860254925598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arden-fair",
      "poi_latitude": "38.6011646",
      "poi_longitude": "-121.4276086",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-920-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-847c-7231-a7e2-5f381c5a8b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-847c-7231-a7e2-5f381c5a8b3b",
        "storage_key": "property/6767906449166892/019d08ad-847c-7231-a7e2-5f381c5a8b3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwm9mh7amoARHgNpmbIyGNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_75f27822-24b0-4820-b510-1b1e1680428c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Ikea Ct, West Sacramento, CA 95605, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of products, including beds, home decor, and Swedish meatballs. They also highlight the reasonable prices, clean and organized environment, and friendly staff.\n\nSome reviews mention the food court can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-dbc8-752a-90c2-e3990a78781b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dbc8-752a-90c2-e3990a78781b",
        "storage_key": "property/6767906449166892/019d08ad-dbc8-752a-90c2-e3990a78781b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/west-sacramento/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=west-sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=1134161977023253649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "38.58660769999999",
      "poi_longitude": "-121.5535253",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-847c-7231-a7e2-5f381c5a8b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-847c-7231-a7e2-5f381c5a8b3b",
        "storage_key": "property/6767906449166892/019d08ad-847c-7231-a7e2-5f381c5a8b3b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzyahGxSo6lQRkcw5Hk9avQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_09ff4c7c-5e53-4a2e-b750-2d1ed27d9fbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Folsom Blvd, Sacramento, CA 95819, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, healthy, and organic foods, including fresh produce, snacks, and frozen meals. They highlight the reasonable prices, especially for flowers and cheese, and the friendly, helpful staff. They also like the well-stocked aisles and the clean, organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-dbd1-773d-8267-dab9d778951c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dbd1-773d-8267-dab9d778951c",
        "storage_key": "property/6767906449166892/019d08ad-dbd1-773d-8267-dab9d778951c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/sacramento/175/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5778462611759847179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.5603947",
      "poi_longitude": "-121.4448167",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-456-1853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e5c-7112-92c0-c4b8fb1df5b1",
        "storage_key": "property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRh5PYDamoARC1fSOSE5MVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fc09b525-3b6f-4ef4-902e-84708e7b70d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento Natural Foods Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "2820 R St, Sacramento, CA 95816, USA",
      "poi_short_description": "Sustainably minded market for seasonal, organic produce as well as meats, fish & specialty foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of natural, organic, and local products, including fresh produce, bulk items, and prepared foods. They highlight the clean, well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-e1b4-739b-9b61-6e91bc143035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e1b4-739b-9b61-6e91bc143035",
        "storage_key": "property/6767906449166892/019d08ad-e1b4-739b-9b61-6e91bc143035.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sac.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451927587609601651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-natural-foods-co-op",
      "poi_latitude": "38.5645864",
      "poi_longitude": "-121.4725986",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-455-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e5c-7112-92c0-c4b8fb1df5b1",
        "storage_key": "property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyB2vvLQmoARc2aH6kVGcNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_93c422e0-1c29-4248-bb6a-3c942f2cb780",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1814 19th St, Sacramento, CA 95811, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers a wide variety of items, including fresh produce, prepared meals, and a deli section with sandwiches. They also highlight the friendly and helpful staff, the clean and well-maintained facility, and the convenient location with ample parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-e220-749a-b8f9-deb79d1864ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e220-749a-b8f9-deb79d1864ae",
        "storage_key": "property/6767906449166892/019d08ad-e220-749a-b8f9-deb79d1864ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/ca/sacramento/1814-19th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9086144474484919629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.5679278",
      "poi_longitude": "-121.4860899",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-492-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e5c-7112-92c0-c4b8fb1df5b1",
        "storage_key": "property/6767906449166892/019d08ad-7e5c-7112-92c0-c4b8fb1df5b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_q7ruDQmoARTU2NU0J4GH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b8d9c7ab-4313-455f-8004-512c32aa8269",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "California State University, Sacramento",
      "poi_type": "Education",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-760a-734f-a088-e2f6568c8157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-760a-734f-a088-e2f6568c8157",
        "storage_key": "property/6767906449166892/019d08ad-760a-734f-a088-e2f6568c8157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520208179546512258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento",
      "poi_latitude": "38.560824",
      "poi_longitude": "-121.423993",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-84c7-776a-a54c-6a8f18633176.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-84c7-776a-a54c-6a8f18633176",
        "storage_key": "property/6767906449166892/019d08ad-84c7-776a-a54c-6a8f18633176.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_TGMY3amoARgls_gjLcPXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b869de11-d91a-484e-9a67-c3b5cebf875d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento City College",
      "poi_type": "Education",
      "poi_address": "3835 Freeport Blvd, Sacramento, CA 95822, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-e3e7-757b-b4a8-87b26f46f3a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e3e7-757b-b4a8-87b26f46f3a2",
        "storage_key": "property/6767906449166892/019d08ad-e3e7-757b-b4a8-87b26f46f3a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=530924599920790724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-college",
      "poi_latitude": "38.5410812",
      "poi_longitude": "-121.4879724",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-558-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-84c7-776a-a54c-6a8f18633176.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-84c7-776a-a54c-6a8f18633176",
        "storage_key": "property/6767906449166892/019d08ad-84c7-776a-a54c-6a8f18633176.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIaIDi03QmoARxIzLVBw5Xgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_957335f5-b836-4188-b5ae-d272d57d4421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Golden 1 Center",
      "poi_type": "Entertainment",
      "poi_address": "500 David J Stern Walk, Sacramento, CA 95814, USA",
      "poi_short_description": "Modern venue built for basketball games, concerts and events, featuring a vegan food station.",
      "poi_long_description": "People say this arena offers a variety of drinks and snacks, and hosts concerts and basketball games. They highlight the comfortable seating, modern design, and excellent sound and video quality. They also like the friendly and helpful staff, and the convenient location with nearby parking and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-289d-77bf-a4a1-51c09f30fcee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-289d-77bf-a4a1-51c09f30fcee",
        "storage_key": "property/6767906449166892/019d08ad-289d-77bf-a4a1-51c09f30fcee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.golden1center.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10987748936193945510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-1-center",
      "poi_latitude": "38.5802045",
      "poi_longitude": "-121.4996602",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-915-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxlrBLxM6IARpi8EH3FTfJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ed8e7d08-5545-4575-a7b1-5f22e4d700e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sutter Health Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Ballpark Dr, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor baseball field features regular sports games, concerts & events, with on-site concessions.",
      "poi_long_description": "People say this stadium offers a variety of seating options, including lawn seats, and has a fun atmosphere with fireworks and activities between innings. They highlight the friendly staff, clean facilities, and the opportunity to see both minor and major league baseball games. They also like the convenient parking and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-e8cb-728e-8e7c-3c6257cb74fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e8cb-728e-8e7c-3c6257cb74fd",
        "storage_key": "property/6767906449166892/019d08ad-e8cb-728e-8e7c-3c6257cb74fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sutterhealthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722204505153287407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-health-park",
      "poi_latitude": "38.5798114",
      "poi_longitude": "-121.5147519",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-376-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-22b9-7008-9e8b-bc66ef295f85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-22b9-7008-9e8b-bc66ef295f85",
        "storage_key": "property/6767906449166892/019d08ae-22b9-7008-9e8b-bc66ef295f85.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnalemcrWmoAR7zShF5M2xyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1c52656e-93a8-4cb8-a0ff-f5ba0416905d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3930 W Land Park Dr, Sacramento, CA 95822, USA",
      "poi_short_description": "Longtime, 14-acre animal park housing native & endangered species, plus a giraffe encounter exhibit.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including big cats, red pandas, and flamingos, and provides opportunities for giraffe feeding and a carousel ride. They also highlight the active animals, well-maintained habitats, and the friendly and knowledgeable staff.\n\nOther reviews mention the zoo can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-307b-732d-903e-6ef3b0fd5890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-307b-732d-903e-6ef3b0fd5890",
        "storage_key": "property/6767906449166892/019d08ad-307b-732d-903e-6ef3b0fd5890.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://saczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430915052866730629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-zoo",
      "poi_latitude": "38.5392791",
      "poi_longitude": "-121.5040041",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-808-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0nl36XRmoARhXrVCiszP1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b62b0790-1a63-4f0e-9d90-2fc9a6b31f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "California State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_long_description": "People say this rail museum offers a collection of locomotives, train cars, and model trains, as well as interactive exhibits and a play area. They highlight the intimate setting, beautiful candlelight concerts, and the friendly and knowledgeable staff and volunteers. They also like the informative signs and the opportunity to explore inside some of the train cars. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-3089-70ed-a2d6-abd720531385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3089-70ed-a2d6-abd720531385",
        "storage_key": "property/6767906449166892/019d08ad-3089-70ed-a2d6-abd720531385.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.californiarailroad.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064911033240821480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-railroad-museum",
      "poi_latitude": "38.5849368",
      "poi_longitude": "-121.5044161",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-323-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-89a2-711d-b5b0-677aeff64a5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-89a2-711d-b5b0-677aeff64a5c",
        "storage_key": "property/6767906449166892/019d08ad-89a2-711d-b5b0-677aeff64a5c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxCsn83WmoAR6J5mJl3jT7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_18d9c902-c165-416c-a56b-4599c7c65d39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "California State Capitol Museum",
      "poi_type": "Entertainment",
      "poi_address": "1315 10th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Elegant, long-standing museum documenting the history of California via exhibits, artifacts & more.",
      "poi_long_description": "Visitors say this history museum offers free tours, a gift shop, and impressive architecture. They also highlight the knowledgeable and friendly tour guides, and the clean and well-maintained building and grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-6e59-71fc-ac4e-7e0304b9a6f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6e59-71fc-ac4e-7e0304b9a6f7",
        "storage_key": "property/6767906449166892/019d08ad-6e59-71fc-ac4e-7e0304b9a6f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.capitolmuseum.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=378875291323442389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-museum",
      "poi_latitude": "38.5765882",
      "poi_longitude": "-121.4932368",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-89a2-711d-b5b0-677aeff64a5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-89a2-711d-b5b0-677aeff64a5c",
        "storage_key": "property/6767906449166892/019d08ad-89a2-711d-b5b0-677aeff64a5c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJldtsqgTWmoAR1aSB8REJQgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4fe36b90-ac5a-4c7d-92f9-67f5108e49ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 7th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Spacious fitness center with cardio machines, weight areas, basketball courts and a pool.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a sauna, steam room, and hot tub. They also highlight the convenient parking, the welcoming and friendly staff, and the positive and uplifting atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-ed66-7788-bbe4-dcaf44f1c412.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-ed66-7788-bbe4-dcaf44f1c412",
        "storage_key": "property/6767906449166892/019d08ad-ed66-7788-bbe4-dcaf44f1c412.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/downtown-sacramento-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640322691779290524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.5808218",
      "poi_longitude": "-121.4983842",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-658-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQN3eyzRmoARnGWwFue8ZUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b712902e-6df1-49e4-a6d1-ad89709decaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1270 W Capitol Ave, Sacramento, CA 95691, USA",
      "poi_short_description": "Chain gym offering 24-hour access, tanning, and various cardio machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-3fad-75dc-a4b4-8f1b3142f547.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3fad-75dc-a4b4-8f1b3142f547",
        "storage_key": "property/6767906449166892/019d08ad-3fad-75dc-a4b4-8f1b3142f547.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/west-sacramento-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9304624826374633257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.582102",
      "poi_longitude": "-121.5247628",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-516-1360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcry8OnXmoARKTdXSPuqIIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f4b14295-d008-4501-abff-1f123fc9a485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3880 Innovator Dr, Sacramento, CA 95834, USA",
      "poi_short_description": "Family-friendly fitness center offering an indoor and outdoor pool plus a kids' zone and climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, indoor and outdoor pools, and a kids' splash area.\n\nOther reviews mention the facilities can be poorly maintained and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-f140-771e-8d60-d089f45c8718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f140-771e-8d60-d089f45c8718",
        "storage_key": "property/6767906449166892/019d08ad-f140-771e-8d60-d089f45c8718.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.inshape.com/gyms/natomas?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1974938444105111114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.639569",
      "poi_longitude": "-121.5083534",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-239-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSiAMj_WmoARStYlHg1kaBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_99efd253-9db5-435b-ae2a-a429a8adde4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "City Sports Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3580 Crocker Dr, Sacramento, CA 95818, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained machines, a clean facility, and friendly, helpful staff. \n\nOther reviews mention the gym can be crowded and membership cancellation can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-f304-738d-82e2-e4ebf92dfb62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f304-738d-82e2-e4ebf92dfb62",
        "storage_key": "property/6767906449166892/019d08ad-f304-738d-82e2-e4ebf92dfb62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.citysportsfitness.com/Pages/clubhome.aspx?clubid=1312&",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663868868192490960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-sports-club",
      "poi_latitude": "38.54227789999999",
      "poi_longitude": "-121.4838807",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-246-1636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffwWZuPRmoAR0NUhYlfQn70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0353f36-a209-4408-b214-fd2a321d546e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "The WELL",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 J St, Sacramento, CA 95819, USA",
      "poi_short_description": "Modern, spacious, on-campus gym featuring weight machines, classes, basketball and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-f785-762e-9920-d06811d114d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f785-762e-9920-d06811d114d9",
        "storage_key": "property/6767906449166892/019d08ad-f785-762e-9920-d06811d114d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thewellatsacstate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5612426490005051286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-well",
      "poi_latitude": "38.5569669",
      "poi_longitude": "-121.4235304",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-278-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUeFxZLamoARlle-IChY400",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0cf6ce5c-1bf7-4dff-91b4-b45c9a4bfc98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Crunch Fitness - Market Square",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Membership-only gym at Market Square at Arden Fair offering group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes. They also highlight the clean facilities, friendly staff, and welcoming atmosphere.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-f9a7-730f-81b6-3c42aec4a1c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f9a7-730f-81b6-3c42aec4a1c7",
        "storage_key": "property/6767906449166892/019d08ad-f9a7-730f-81b6-3c42aec4a1c7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/marketsquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728157417301185125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---market-square",
      "poi_latitude": "38.5994681",
      "poi_longitude": "-121.4232353",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-913-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZ8uG_3bmoARZZJxRD4RB_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_39889294-78d9-4a8f-b55f-b66452da5f2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento Central YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 W St, Sacramento, CA 95818, USA",
      "poi_short_description": "Community fitness center with a swimming pool and classes, plus programs for children.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, group exercise classes, and a large, heated indoor pool. They also highlight the friendly and helpful staff, the welcoming and inclusive atmosphere, and the clean facilities.\n\nOther reviews mention the facilities can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-f9be-763d-aa00-27427861382b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f9be-763d-aa00-27427861382b",
        "storage_key": "property/6767906449166892/019d08ad-f9be-763d-aa00-27427861382b.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://www.ymcasuperiorcal.org/sacramentoymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5417990014250751205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-ymca",
      "poi_latitude": "38.5623639",
      "poi_longitude": "-121.4855257",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-452-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTUhHi-PQmoAR5ZQHVDaRMEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f2d6d2a5-da43-4496-bc78-b76e416616bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-6c76-72ce-80a6-99c939db048f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6c76-72ce-80a6-99c939db048f",
        "storage_key": "property/6767906449166892/019d08ad-6c76-72ce-80a6-99c939db048f.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8eff-73f8-b666-33c3e2765fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8eff-73f8-b666-33c3e2765fcc",
        "storage_key": "property/6767906449166892/019d08ad-8eff-73f8-b666-33c3e2765fcc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9ac207ff-f383-4583-ba5f-6fd07631c255",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sacramento Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2025 Morse Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-fc98-7549-8eeb-cae49641c9e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fc98-7549-8eeb-cae49641c9e8",
        "storage_key": "property/6767906449166892/019d08ad-fc98-7549-8eeb-cae49641c9e8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/northern-california/facilities/Sacramento-Medical-Center-100330",
      "poi_directions_map_url": "https://maps.google.com/?cid=825758789253687625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-sacramento-medical-center",
      "poi_latitude": "38.6021267",
      "poi_longitude": "-121.3924928",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-973-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8eff-73f8-b666-33c3e2765fcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8eff-73f8-b666-33c3e2765fcc",
        "storage_key": "property/6767906449166892/019d08ad-8eff-73f8-b666-33c3e2765fcc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24Jpp87bmoARSWmfZz6vdQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_04ddf55c-bc6f-4c11-95a4-a5ca5559feaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sacramento, CA 95833, USA",
      "poi_short_description": "302-acre park featuring a 32-mile bike trail, ball fields, picnic sites, fishing & boat launches.",
      "poi_long_description": "People say this park offers a boat launch, fishing, and picnic areas with barbecue grills and shade. They also highlight the spacious layout, the American River bike trail, and the beautiful views of the river confluence.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-53bf-716c-8b17-ce4beeb0138d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-53bf-716c-8b17-ce4beeb0138d",
        "storage_key": "property/6767906449166892/019d08ad-53bf-716c-8b17-ce4beeb0138d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/DiscoveryPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608359273538838528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "38.6057626",
      "poi_longitude": "-121.50348",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8a38-751a-9fc1-68a2406db206",
        "storage_key": "property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARAOBwJ7-btVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eac29b17-2284-4048-bf5e-884480258421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "McKinley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Alhambra Blvd, Sacramento, CA 95816, USA",
      "poi_short_description": "Relaxing preserve featuring a rose garden, seasonal pool, playgrounds, tennis courts & trails.",
      "poi_long_description": "Visitors say this park offers a relaxing atmosphere with a beautiful rose garden, perfect for long walks or jogs, and a pond where you can feed the ducks. They also highlight the well-maintained park, spacious for picnics, and fun for kids with a large playground and a nearby public pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-0108-724f-b233-ea63d0a68a5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0108-724f-b233-ea63d0a68a5a",
        "storage_key": "property/6767906449166892/019d08ae-0108-724f-b233-ea63d0a68a5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofsacramento.org/ParksandRec/Parks/Park-Directory/Central-City/McKinley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817515343663866372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinley-park",
      "poi_latitude": "38.5768935",
      "poi_longitude": "-121.4630764",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-808-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8a38-751a-9fc1-68a2406db206",
        "storage_key": "property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6sj4JfQmoARBCIIjDDSPog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_74473fa9-d0fa-4bc2-9f83-c648ff1d9906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Haggin Oaks Golf Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3645 Fulton Ave, Sacramento, CA 95821, USA",
      "poi_short_description": "Historic golf complex featuring 2 18-hole courses, plus a driving range, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers quality lessons, clean and well-maintained courses, and a huge driving range. They highlight the late-night driving range and food trucks, and the enjoyable experience of hitting balls and dining at the MacKenzie Grill. They also like the instructors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-00e2-722b-84d4-e5efd9a3fbd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-00e2-722b-84d4-e5efd9a3fbd6",
        "storage_key": "property/6767906449166892/019d08ae-00e2-722b-84d4-e5efd9a3fbd6.webp",
        "width": 996,
        "height": 657
      },
      "poi_business_url": "https://www.hagginoaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6467797662234953962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haggin-oaks-golf-complex",
      "poi_latitude": "38.633561",
      "poi_longitude": "-121.4033421",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-808-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-26a6-705c-a0a1-06351d45a99b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-26a6-705c-a0a1-06351d45a99b",
        "storage_key": "property/6767906449166892/019d08ae-26a6-705c-a0a1-06351d45a99b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJz69Jx6HZmoAR6siduLQ7wlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_058eb529-9c86-4a87-a4f8-bf947ae5824a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "California State Capitol Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 L St, Sacramento, CA 95814, USA",
      "poi_short_description": "Scenic city green space with monuments, memorials, flower gardens & walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, exotic trees, and historic monuments, including a rose garden and memorials to veterans and firefighters. They highlight the peaceful and relaxing vibe, and the well-maintained grounds with clear signage. They also like that the park is dog-friendly and provides opportunities for learning about botany and history. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-0232-73c5-b28b-ffc0fdefdb44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0232-73c5-b28b-ffc0fdefdb44",
        "storage_key": "property/6767906449166892/019d08ae-0232-73c5-b28b-ffc0fdefdb44.webp",
        "width": 640,
        "height": 853
      },
      "poi_business_url": "https://capitolmuseum.ca.gov/learn/about-the-capitol/capitol-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5243745298811035407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-park",
      "poi_latitude": "38.5759282",
      "poi_longitude": "-121.4907022",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8a38-751a-9fc1-68a2406db206",
        "storage_key": "property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVIWBdjQmoARD59BFJGGxUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9f3752e4-c060-4c7f-a422-f9deaf2fbc32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "State Capitol Park World Peace Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1317 15th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Peace-themed Victorian style rose garden within a park, with a fountain & pavilion.",
      "poi_long_description": "Visitors say this rose garden offers a tranquil experience with hundreds of varieties of roses in bloom, as well as trees from all over the world. They also highlight the well-maintained park, peaceful atmosphere, and educational value of the different rose species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-04c4-757c-b3fb-79518055ed52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-04c4-757c-b3fb-79518055ed52",
        "storage_key": "property/6767906449166892/019d08ae-04c4-757c-b3fb-79518055ed52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://worldpeacerosegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381262157938595809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-capitol-park-world-peace-rose-garden",
      "poi_latitude": "38.575501",
      "poi_longitude": "-121.4883327",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-381-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8a38-751a-9fc1-68a2406db206",
        "storage_key": "property/6767906449166892/019d08ad-8a38-751a-9fc1-68a2406db206.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_Yds9nQmoAR4ZeeSZ06KxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_342c884c-a9b7-40cb-8983-cdc8ab49b4f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "University/65th Street Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-0a45-722a-9c22-ee546b59502d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0a45-722a-9c22-ee546b59502d",
        "storage_key": "property/6767906449166892/019d08ae-0a45-722a-9c22-ee546b59502d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3002021551157189183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university65th-street-station-wb",
      "poi_latitude": "38.55265",
      "poi_longitude": "-121.42749",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77gV9pPamoARP5rKBLJSqSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b8dd7e81-872d-4303-a95a-59b4b27557af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento Valley Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-0a53-7605-a847-93c835661c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0a53-7605-a847-93c835661c53",
        "storage_key": "property/6767906449166892/019d08ae-0a53-7605-a847-93c835661c53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6346517780329793861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-valley-station-wb",
      "poi_latitude": "38.584627",
      "poi_longitude": "-121.500439",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncYA5dLWmoARRQlCwUtcE1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b1205459-2647-4678-9cfe-8696a7777180",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Arden/Del Paso Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95815, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-0ab9-765c-b61a-3839880c8cf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0ab9-765c-b61a-3839880c8cf2",
        "storage_key": "property/6767906449166892/019d08ae-0ab9-765c-b61a-3839880c8cf2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=567876029887657118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ardendel-paso-station-eb",
      "poi_latitude": "38.606207",
      "poi_longitude": "-121.456274",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd59FpVrXmoARnrTpjT2A4Qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c904b3fe-26cd-4bd0-9f6d-0933304cfbf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "7th & Capitol",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-1061-715f-8c4b-b1a739d37e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1061-715f-8c4b-b1a739d37e46",
        "storage_key": "property/6767906449166892/019d08ae-1061-715f-8c4b-b1a739d37e46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048847390555747041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7th--capitol",
      "poi_latitude": "38.5783062",
      "poi_longitude": "-121.4989023",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTq-mS7RmoAR4bI7p_MbEUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ba0aee57-f6e8-469f-8cdd-0f5b785e6b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "16th Street Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-124a-719f-8e6d-7a019d46ac8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-124a-719f-8e6d-7a019d46ac8a",
        "storage_key": "property/6767906449166892/019d08ae-124a-719f-8e6d-7a019d46ac8a.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4554807020176890849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "16th-street-station-eb",
      "poi_latitude": "38.5697554",
      "poi_longitude": "-121.4891647",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJowcyqN_QmoAR4VsZOtrsNT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_182a809b-0f52-458d-ad31-6d840350357e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "915 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-12fc-73f4-a23a-334084d902a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-12fc-73f4-a23a-334084d902a8",
        "storage_key": "property/6767906449166892/019d08ae-12fc-73f4-a23a-334084d902a8.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.cityofsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5261544109164931557&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-hall",
      "poi_latitude": "38.5823421",
      "poi_longitude": "-121.4933431",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-264-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8f1c-754e-9325-72490fa2df15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8f1c-754e-9325-72490fa2df15",
        "storage_key": "property/6767906449166892/019d08ad-8f1c-754e-9325-72490fa2df15.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9NSRSrRmoAR5SnTjH3CBEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_ccb5624e-8949-42e2-9532-0f6da4fa98de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Blue Diamond Growers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1802 C St, Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-1315-735c-8fb1-3af61de3bef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1315-735c-8fb1-3af61de3bef0",
        "storage_key": "property/6767906449166892/019d08ae-1315-735c-8fb1-3af61de3bef0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bluediamondgrowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247972805344263985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-diamond-growers",
      "poi_latitude": "38.5857959",
      "poi_longitude": "-121.4810041",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-442-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7CwctLQmoARMX_AVi5lfOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1c34fc6d-2014-430e-b9e7-bfe1806d5460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "City of West Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1110 W Capitol Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-1890-7269-b3b6-4e87c8ecd2c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1890-7269-b3b6-4e87c8ecd2c7",
        "storage_key": "property/6767906449166892/019d08ae-1890-7269-b3b6-4e87c8ecd2c7.webp",
        "width": 1280,
        "height": 808
      },
      "poi_business_url": "http://www.cityofwestsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5233966858684488344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-west-sacramento-city-hall",
      "poi_latitude": "38.58203210000001",
      "poi_longitude": "-121.5234091",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-617-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-8f1c-754e-9325-72490fa2df15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8f1c-754e-9325-72490fa2df15",
        "storage_key": "property/6767906449166892/019d08ad-8f1c-754e-9325-72490fa2df15.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUyoorHWmoARmFoOkiDJokg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f453ee0d-de32-4e73-ac37-36e3fca3a7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Resources Building - State of California",
      "poi_type": "Major Employers & Offices",
      "poi_address": "715 P St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-1935-7038-9671-b1124d3132ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1935-7038-9671-b1124d3132ac",
        "storage_key": "property/6767906449166892/019d08ae-1935-7038-9671-b1124d3132ac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://resources.ca.gov/About-Us/our-new-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310981311370573820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resources-building---state-of-california",
      "poi_latitude": "38.5752007",
      "poi_longitude": "-121.4993404",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-367-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9oPNi_RmoAR_DcbZPoaurg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_240901c5-10b2-4149-9072-9a1dafd016ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "poi_name": "Centene Campus Natomas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 E Commerce Way, Sacramento, CA 95834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ae-1ac5-722e-badd-259bc9749ccf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1ac5-722e-badd-259bc9749ccf",
        "storage_key": "property/6767906449166892/019d08ae-1ac5-722e-badd-259bc9749ccf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9616052681257976114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centene-campus-natomas",
      "poi_latitude": "38.6466286",
      "poi_longitude": "-121.5240407",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 314-725-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e1f-7019-a846-1250af1d1485",
        "storage_key": "property/6767906449166892/019d08ad-7e1f-7019-a846-1250af1d1485.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaddcK4jXmoARMgHTL_cUc4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_82ec106a-1e45-4e84-9005-4a7ef64c914e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_d043c8db-63a1-4f96-afd0-af898ba05658",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_5855571f-acee-4822-ba8d-5e015aa66b11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_bc1935cf-4d46-4c85-9825-35ec6f543a85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_6ed8bab4-bb05-409a-8748-84eccccebaa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e045e864-ae73-4d10-83e8-fb106d87b8a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_f8a1f009-5133-490a-9133-c73625a286a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "rating": "5.0",
      "name": "Patty Hanson",
      "text": "Can't wait to move in! So looking forward to moving in!\nAmeneded review:\nHave been here for 3? years, and love it! Great neighbors, quiet, and love my garage! They have been busy doing upgrades/clean-up of the property. Lookin' good! And staff is great. Never had a problem with not hearing back from someone if I ever had a concern. And the only bugs we have ever seen is the usual spiders during spider season and ants. But the pest control guy does a great job at keeping them at bay. Will continue to ,live here.",
      "date": "2018-10-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ec4480a6-acc6-46ea-9011-2910d99f7541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-240c-747f-b039-fc611ccc0fe9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-240c-747f-b039-fc611ccc0fe9",
        "storage_key": "property/6767906449166892/019d2b61-240c-747f-b039-fc611ccc0fe9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe - 1 Bedroom 1 Bath 770 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=e1L52pQJtCp"
    },
    {
      "id": "custom_14212dbd-9af0-4be1-a54b-2d0f5d2a3836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-3db4-7648-bb3d-a28e688a176e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-3db4-7648-bb3d-a28e688a176e",
        "storage_key": "property/6767906449166892/019d2b61-3db4-7648-bb3d-a28e688a176e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - 2 Bedroom 2 Bath 1119 Sq. Ft. Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tpC2Xm9mc8Q&brand=0"
    },
    {
      "id": "custom_f7b2c5bc-8fcc-4c6e-b540-ae80b01e6241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-53f8-751e-bb31-1c8ffbaa9b3b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-53f8-751e-bb31-1c8ffbaa9b3b",
        "storage_key": "property/6767906449166892/019d2b61-53f8-751e-bb31-1c8ffbaa9b3b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - 2 Bedroom 2 Bath 1004 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kKpKoFaANDZ"
    },
    {
      "id": "custom_92ce575c-58d5-45b2-af65-eb3f9dc19463",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-6c7b-76eb-9787-d815fcc97987.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-6c7b-76eb-9787-d815fcc97987",
        "storage_key": "property/6767906449166892/019d2b61-6c7b-76eb-9787-d815fcc97987.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - 2 Bedroom 2 Bath 1070 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oZjUSRFeYRb"
    },
    {
      "id": "custom_4ad0fb65-1d1e-4f29-b284-acf2fd4a2d83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-84ea-753b-a484-ee875ab2dd3b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-84ea-753b-a484-ee875ab2dd3b",
        "storage_key": "property/6767906449166892/019d2b61-84ea-753b-a484-ee875ab2dd3b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - 3 Bedroom 2 Bath 1,290 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=t5H4CJPwkJx"
    },
    {
      "id": "custom_a7120ce4-1325-42cf-b11e-171588128426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-9f30-74dc-8f4c-d407cea82e91.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-9f30-74dc-8f4c-d407cea82e91",
        "storage_key": "property/6767906449166892/019d2b61-9f30-74dc-8f4c-d407cea82e91.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Delta Pointe Apartments - 3 Bedroom 2 Bath 1413 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YcNgptz5Qey"
    },
    {
      "id": "custom_c622f462-4e94-4c18-ab45-3dccd57f8388",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-bab8-7359-be26-2f142ce37bac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-bab8-7359-be26-2f142ce37bac",
        "storage_key": "property/6767906449166892/019d2b61-bab8-7359-be26-2f142ce37bac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kwKzon28npk"
    },
    {
      "id": "custom_07e2d421-cd49-48e3-9ab5-0cf25c3001ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-d8f4-76de-999a-428dd090f215.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-d8f4-76de-999a-428dd090f215",
        "storage_key": "property/6767906449166892/019d2b61-d8f4-76de-999a-428dd090f215.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - Fitness Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mgcJwW9zH3k"
    },
    {
      "id": "custom_0e14eb91-6663-4c8c-9c05-c56ac83a61fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166892/019d2b61-f49e-737c-8401-f6ca7edbcc52.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b61-f49e-737c-8401-f6ca7edbcc52",
        "storage_key": "property/6767906449166892/019d2b61-f49e-737c-8401-f6ca7edbcc52.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Delta Pointe Apartments - Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3uqVuzjewRm"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a4-17b2-76fe-afb4-6786529c05ac",
      "lead_source": "LANDING_PAGE",
      "name": "Delta Pointe Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "rentals-fitness-center-north-sacramento",
      "search_query": "rentals with fitness center North Sacramento",
      "category": "Amenity",
      "h1_title": "Rentals with Fitness Center in North Sacramento",
      "h2_subtitle": "Explore rentals featuring a fitness center in North Sacramento. Felta Point offers modern amenities in this vibrant neighborhood.",
      "page_copy": "Discover the vibrant living experience at Felta Point, where rentals with fitness center options in North Sacramento provide an enhanced lifestyle. Our community boasts a state-of-the-art Fitness Center with free Wi‑Fi, making it easy for residents to maintain their fitness goals without leaving home. Located in the heart of North Sacramento, Felta Point invites you to live a balanced life with access to premier facilities. \n\nBeyond the fitness amenities, residents enjoy additional comforts such as two sparkling swimming pools, centralized heating and air, and even a tennis court—perfect for athletic enthusiasts. Experience the convenience and community at Felta Point in Sacramento County, where you can unwind and thrive in stylishly designed rentals.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals with Fitness Center in North Sacramento",
      "seo_description": "Find rentals with a fitness center at Felta Point, North Sacramento. Enjoy pools, tennis courts, and more in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-sacramento-county",
      "search_query": "apartments with in-unit laundry Sacramento County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Sacramento County",
      "h2_subtitle": "Find spacious apartments with in-unit laundry in Sacramento County. Experience comfort and convenience at Felta Point.",
      "page_copy": "Welcome to Felta Point, where comfort meets convenience in our apartments with in-unit laundry located in Sacramento County. Experience the ease of managing your daily tasks with this essential amenity right at your fingertips. No more shared laundry rooms or laundromats—just the privacy and efficiency you deserve. \n\nBeyond the convenience of in-unit laundry, our community offers an array of amenities designed for modern living. Enjoy access to our fitness center with free Wi-Fi, two refreshing swimming pools, centralized heating and air, and a tennis court. Situated in North Sacramento, Felta Point is nestled within a lively neighborhood that provides residents with the perfect blend of comfort, style, and community engagement.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Sacramento County",
      "seo_description": "Discover Felta Point's Sacramento County apartments with in-unit laundry. Enjoy modern amenities like a fitness center, pools, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-bark-park-95833",
      "search_query": "pet-friendly apartments with bark park 95833",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Bark Park in 95833",
      "h2_subtitle": "Discover pet-friendly apartments with a bark park in the 95833 area. Felta Point welcomes you and your furry friends!",
      "page_copy": "At Felta Point, we understand that pets are family, which is why our pet-friendly apartments in the 95833 area are designed to welcome all your family members. Enjoy the freedom of exploring our dedicated bark park, where your furry friends can play, socialize, and exercise in a safe environment. \n\nBeyond our pet-friendly features, Felta Point offers a variety of amenities for our human residents, including a fitness center with free Wi-Fi, two beautiful swimming pools, centralized heating and air, and a tennis court. Situated in Sacramento County's vibrant North Sacramento neighborhood, our community provides both pets and their owners a perfect blend of convenience, comfort, and camaraderie.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Bark Park in 95833",
      "seo_description": "Explore pet-friendly living at Felta Point in 95833, complete with a bark park. Enjoy amenities like pools and a fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "swimming-pool-apartments-sacramento-ca",
      "search_query": "swimming pool apartments Sacramento CA",
      "category": "Amenity",
      "h1_title": "Swimming Pool Apartments in Sacramento, CA",
      "h2_subtitle": "Dive into luxury living with swimming pool apartments in Sacramento, CA. Experience the lifestyle at Felta Point.",
      "page_copy": "Welcome to Felta Point, where our swimming pool apartments in Sacramento, CA, redefine upscale urban living. Reside in style and chill by our two sparkling swimming pools, the perfect place to unwind, exercise, or socialize with neighbors. Located in the vibrant North Sacramento area, our community offers the ideal blend of leisure and modern conveniences.\n\nBeyond our fabulous pools, residents benefit from top-notch amenities such as a fully-equipped fitness center with free Wi-Fi, centralized heating and air, a tennis court, and more. Experience the lifestyle you deserve in Sacramento County's premier residential community at Felta Point, where every day feels like a vacation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Swimming Pool Apartments in Sacramento, CA",
      "seo_description": "Find your perfect home at Felta Point in Sacramento, CA, featuring apartments with swimming pools and other great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-sacramento",
      "search_query": "apartments with air conditioning Sacramento",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Sacramento",
      "h2_subtitle": "Stay cool with air-conditioned apartments in Sacramento. Discover comfort at Felta Point.",
      "page_copy": "Experience unparalleled comfort at Felta Point, where our air-conditioned apartments in Sacramento offer the perfect respite from the California heat. Each unit is equipped with centralized heating and air, ensuring a comfortable environment all year round. Nestled in the heart of Sacramento's vibrant North Sacramento neighborhood, our community caters to those who value modern convenience and style.\n\nFelta Point isn't just about staying cool; it's about enjoying a comprehensive living experience. Take advantage of our on-site amenities including a fully-equipped fitness center with free Wi-Fi, two inviting swimming pools, and a tennis court. At Felta Point, you don’t just find a home—you discover a lifestyle tailored to comfort and relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Sacramento",
      "seo_description": "Discover Felta Point's air-conditioned apartments in Sacramento with modern amenities like pools, fitness center, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-north-sacramento",
      "search_query": "one bedroom apartments North Sacramento",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Sacramento",
      "h2_subtitle": "Explore modern one bedroom apartments in North Sacramento. Felta Point offers comfort and convenience in style.",
      "page_copy": "Felta Point invites you to discover the perfect blend of comfort and style in our one bedroom apartments located in North Sacramento. Designed with contemporary living in mind, these spacious units offer the ideal retreat after a long day. Situated in a vibrant neighborhood, our community promises a lifestyle enriched with convenience and relaxation.\n\nResidents of Felta Point benefit from an array of amenities that complement their living experience, including a fitness center with free Wi-Fi, two sparkling swimming pools, centralized heating and air, and a tennis court. Located in Sacramento County, our one bedroom apartments are the gateway to a sophisticated and enjoyable lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in North Sacramento",
      "seo_description": "Discover Felta Point's one bedroom apartments in North Sacramento, offering top amenities like a pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-95833",
      "search_query": "two bedroom apartments near 95833",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 95833",
      "h2_subtitle": "Find spacious two bedroom apartments near 95833. Felta Point offers a superior living experience in Sacramento.",
      "page_copy": "Welcome to Felta Point, where you'll discover beautifully designed two bedroom apartments near the 95833 area, perfect for those seeking ample space and modern amenities. Set in the vibrant community of North Sacramento, our apartments provide an ideal environment for families, roommates, or anyone needing a little extra room.\n\nYour home isn’t just confined to your apartment; enjoy our range of community amenities including a fitness center with free Wi-Fi, two refreshing swimming pools, centralized heating and air, and a tennis court. Experience the perfect balance of luxury and convenience at Felta Point, where your next apartment near the 95833 zip code awaits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 95833",
      "seo_description": "Explore Felta Point's two bedroom apartments near 95833 in Sacramento featuring pools, fitness center, and more amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-sacramento-county",
      "search_query": "three bedroom apartments Sacramento County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Sacramento County. Felta Point offers a premium living experience.",
      "page_copy": "Felta Point presents an exceptional collection of three bedroom apartments located in Sacramento County, ideal for those who need plenty of living space. These thoughtfully designed apartments provide a perfect mix of style and functionality, ensuring that every family member or roommate enjoys their comfort.\n\nNestled in North Sacramento, Felta Point offers more than just stunning apartments. Our residents enjoy access to premium community amenities, including a fully-equipped fitness center with free Wi-Fi, two swimming pools, centralized heating and air, and a tennis court. Embrace a higher standard of living with our three bedroom options, providing the perfect backdrop for your life in Sacramento County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Sacramento County",
      "seo_description": "Explore spacious three bedroom apartments at Felta Point in Sacramento County with top-notch amenities like pools and a fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-near-california-state-university-sacramento",
      "search_query": "apartments near california state university sacramento",
      "category": "School",
      "h1_title": "Apartments Near California State University",
      "h2_subtitle": "Find ideal apartments near California State University, Sacramento. Experience comfortable living at Felta Point.",
      "page_copy": "Located just a short drive from California State University, Sacramento, Felta Point offers a convenient living option for students and faculty looking for comfortable apartments near campus. Our community presents modern amenities that cater to a balanced lifestyle.\n\nWhether you wish to relax by the pool or stay active at home, our two swimming pools and fitness center with free Wi-Fi are just a few of the conveniences you'll enjoy. Nestled in North Sacramento, our location makes Felta Point a practical choice for those associated with the university, enhancing your academic and professional pursuits with comfort and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near California State University",
      "seo_description": "Discover Felta Point's comfortable apartments near California State University, Sacramento with amenities like pools and a fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-by-sacramento-city-college-north-sacramento",
      "search_query": "apartments by sacramento city college north sacramento",
      "category": "School",
      "h1_title": "Apartments by Sacramento City College",
      "h2_subtitle": "Explore desirable apartments by Sacramento City College in North Sacramento. Felta Point offers a perfect home base for students and staff.",
      "page_copy": "Felta Point is ideally situated close to Sacramento City College's North Sacramento campus, providing convenient apartment living for students and faculty. Our spacious units are complemented by top-tier amenities, ensuring a comfortable and productive lifestyle.\n\nYou'll love the variety of amenities available, including a fitness center with free Wi-Fi, two inviting swimming pools, and a tennis court to help unwind after a study session or workday. Located in vibrant North Sacramento, Felta Point is the perfect home for anyone looking to balance academic life with modern comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Sacramento City College",
      "seo_description": "Live near Sacramento City College in North Sacramento at Felta Point, offering comfortable apartments with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-near-uc-davis-medical-center-sacramento",
      "search_query": "apartments near UC Davis Medical Center Sacramento",
      "category": "Hospital",
      "h1_title": "Apartments Near UC Davis Medical Center",
      "h2_subtitle": "Discover convenient apartments near UC Davis Medical Center in Sacramento. Felta Point offers comfort and accessibility.",
      "page_copy": "Felta Point is an excellent choice for those seeking apartments near UC Davis Medical Center in Sacramento. Our convenient location in North Sacramento makes commuting a breeze, whether you're a medical professional, student, or visitor seeking proximity to this renowned healthcare facility.\n\nResidents enjoy a variety of amenities designed to enhance their quality of life, including a fitness center with free Wi-Fi, two sparkling swimming pools, and a tennis court—all within reach of UC Davis Medical Center. At Felta Point, you’ll find a perfect blend of location and lifestyle that supports your health and wellness aspirations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UC Davis Medical Center",
      "seo_description": "Find conveniently located apartments near UC Davis Medical Center in Sacramento at Felta Point, complete with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "living-near-kaiser-permanente-sacramento-medical-center",
      "search_query": "living near Kaiser Permanente Sacramento Medical Center North Sacramento",
      "category": "Hospital",
      "h1_title": "Living Near Kaiser Permanente Sacramento",
      "h2_subtitle": "Experience convenient living near Kaiser Permanente Sacramento Medical Center in North Sacramento. Enjoy modern comforts at Felta Point.",
      "page_copy": "Felta Point provides an ideal living solution for those seeking proximity to Kaiser Permanente Sacramento Medical Center in North Sacramento. Our community offers a blend of modern amenities and a location that meets the needs of healthcare professionals and families.\n\nResidents at Felta Point enjoy central heating and air conditioning, two sparkling swimming pools, and a well-equipped fitness center with free Wi-Fi. The convenience of living close to Kaiser Permanente means less time commuting and more time enjoying the vibrant neighborhood and the comfort of your own home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Kaiser Permanente Sacramento",
      "seo_description": "Discover Felta Point's comfort and convenience, perfectly situated near Kaiser Permanente Sacramento Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-near-discovery-park-sacramento",
      "search_query": "apartments near Discovery Park Sacramento",
      "category": "Park",
      "h1_title": "Apartments Near Discovery Park",
      "h2_subtitle": "Find beautiful apartments near Discovery Park in Sacramento. Felta Point offers a blend of nature, convenience, and comfort.",
      "page_copy": "Nestled near the scenic Discovery Park in Sacramento, Felta Point offers apartments that perfectly balance nature and city living. Our prime location allows residents to enjoy easy access to miles of biking trails, picnic areas, and the serene beauty of the Sacramento River.\n\nFelta Point provides a variety of amenities, including two refreshing swimming pools and a tennis court, making it easy to enjoy recreational activities. Centralized heating and air ensure comfort throughout the year, while our fitness center with free Wi-Fi supports active lifestyles. Experience the ideal mix of community and nature just minutes from Discovery Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Discovery Park",
      "seo_description": "Explore Felta Point apartments near Discovery Park. Enjoy proximity to nature and modern amenities in Sacramento.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "felta-point-apartments-by-mckinley-park-95833",
      "search_query": "Felta Point apartments by McKinley Park 95833",
      "category": "Park",
      "h1_title": "Felta Point Apartments by McKinley Park",
      "h2_subtitle": "Explore Felta Point Apartments conveniently located by McKinley Park in the 95833 area. Enjoy modern living in a vibrant community.",
      "page_copy": "Located in the vibrant 95833 area, Felta Point Apartments offer exceptional living just a short drive from picturesque McKinley Park. Perfect for those who value proximity to lush greenery and recreational facilities, our community provides modern conveniences in a lively environment.\n\nFelta Point is equipped with a range of resident-focused amenities, including two inviting swimming pools and a fully-equipped fitness center with free Wi-Fi. The centralized heating and air offer comfort year-round, and the tennis court is perfect for staying active. Enjoy the blend of comfort and location near McKinley Park at Felta Point Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Felta Point Apartments by McKinley Park",
      "seo_description": "Choose Felta Point for modern living by McKinley Park, 95833. Enjoy top amenities in a lively Sacramento community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "north-sacramento-rentals-near-capitol-park",
      "search_query": "California State Capitol Park nearby North Sacramento rentals",
      "category": "Park",
      "h1_title": "Rentals Near Capitol Park in North Sacramento",
      "h2_subtitle": "Discover North Sacramento rentals near California State Capitol Park. Felta Point offers the ideal location for convenience and leisure.",
      "page_copy": "Nestled in North Sacramento, Felta Point offers rentals that are conveniently located near California State Capitol Park, one of the city's premier landmarks. Living here means you're just a short drive away from engaging city events, historical tours, and the vibrant life surrounding the Capitol.\n\nAt Felta Point, we prioritize both comfort and lifestyle. Our community features centralized heating and air, two refreshing swimming pools, and a tennis court for residents who love to stay active. Enjoy modern apartment living with effortless access to the cultural and political heart of Sacramento, all while enjoying the peaceful atmosphere of a welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Capitol Park, North Sacramento",
      "seo_description": "Find North Sacramento rentals at Felta Point near Capitol Park. Enjoy modern living near iconic Sacramento landmarks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "apartments-near-university-65th-street-station-sacramento",
      "search_query": "apartments near University/65th Street Station Sacramento",
      "category": "Transit",
      "h1_title": "Apartments Near University/65th Street Station",
      "h2_subtitle": "Explore Felta Point, offering accessible apartments near University/65th Street Station, Sacramento. Discover convenient living close to transit.",
      "page_copy": "Felta Point is ideally situated for those seeking the convenience of nearby transit with our apartments located close to the University/65th Street Station in Sacramento. This prime location simplifies commuting and offers easy access to local colleges, eateries, and entertainment options along the transit line.\n\nResidents at Felta Point enjoy a wide array of amenities that enhance everyday living. The on-site fitness center with free Wi-Fi supports active lifestyles, while our two sparkling swimming pools provide a refreshing escape. With centralized heating, air, and a flexible layout, our apartments cater to modern needs, making it an excellent choice for those utilizing the University/65th Street Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University/65th Street Station",
      "seo_description": "Discover Felta Point apartments near University/65th Street Station in Sacramento, blending convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "felta-point-near-sacramento-valley-station",
      "search_query": "Felta Point near Sacramento Valley Station",
      "category": "Transit",
      "h1_title": "Felta Point by Sacramento Valley Station",
      "h2_subtitle": "Discover Felta Point located conveniently near Sacramento Valley Station. Enjoy seamless connectivity and modern amenities.",
      "page_copy": "Situated in the vibrant area near Sacramento Valley Station, Felta Point offers an ideal blend of location and lifestyle. This prime positioning allows easy access to Sacramento's transit hub, perfect for commuters and frequent travelers alike.\n\nAt Felta Point, residents enjoy a host of amenities designed for contemporary living. Our community boasts two shimmering swimming pools, a state-of-the-art fitness center with complimentary Wi-Fi, and a dedicated tennis court. With centralized heating and air, our apartments guarantee comfort all year round, while microwaves and modern layouts make daily living convenient and enjoyable. Experience the convenience of living near Sacramento Valley Station at Felta Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Felta Point by Sacramento Valley Station",
      "seo_description": "Find unparalleled convenience at Felta Point near Sacramento Valley Station. Enjoy top amenities and seamless city connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "north-sacramento-living-near-arden-del-paso-station",
      "search_query": "North Sacramento living near Arden/Del Paso Station",
      "category": "Transit",
      "h1_title": "North Sacramento Living by Arden/Del Paso",
      "h2_subtitle": "Experience North Sacramento living near Arden/Del Paso Station at Felta Point. Enjoy convenient transit access and community amenities.",
      "page_copy": "Discover the charm of North Sacramento living at Felta Point, located near the Arden/Del Paso Station. Here, residents enjoy an effortless commute with easy access to the Sacramento light rail system, making travel to downtown, local colleges, and entertainment venues a breeze.\n\nFelta Point is more than just a place to stay; it's a community designed around lifestyle-enhancing amenities. Our residents benefit from a fitness center equipped with free Wi-Fi, two inviting swimming pools, and a well-maintained tennis court. Each apartment is thoughtfully designed with modern conveniences like centralized heating and air, ensuring a comfortable environment. Live close to Arden/Del Paso Station and enjoy all that North Sacramento has to offer at Felta Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Sacramento Living by Arden/Del Paso",
      "seo_description": "Live conveniently at Felta Point near Arden/Del Paso Station in North Sacramento. Experience modern amenities and seamless transit options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "sacramento-apartments-near-7th-capitol",
      "search_query": "Sacramento apartments near 7th & Capitol",
      "category": "Transit",
      "h1_title": "Sacramento Apartments Near 7th & Capitol",
      "h2_subtitle": "Explore Felta Point, offering convenient Sacramento apartments near 7th & Capitol. Enjoy top-tier amenities and seamless access to downtown.",
      "page_copy": "Felta Point is your gateway to optimal urban living with our Sacramento apartments positioned near 7th & Capitol. This location places you at the center of the city, combining the convenience of proximity to downtown shops and dining with easy access to public transit options.\n\nOur community is designed for those who value a blend of comfort and convenience. Felta Point features premium amenities such as a fitness center with free Wi-Fi, two relaxing swimming pools, and a well-appointed tennis court. Each apartment comes equipped with centralized heating and air, catering to the needs of contemporary living. Experience the vibrancy of living near 7th & Capitol, where everything Sacramento has to offer is just at your doorstep, while enjoying the laid-back luxury of Felta Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento Apartments Near 7th & Capitol",
      "seo_description": "Live at Felta Point, Sacramento's stylish apartments near 7th & Capitol, offering great amenities and easy downtown access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166892",
      "source": "generator",
      "page_item_url": "16th-street-station-nearby-apartments-sacramento",
      "search_query": "16th Street Station nearby apartments in Sacramento County",
      "category": "Transit",
      "h1_title": "Apartments Near 16th Street Station, Sacramento",
      "h2_subtitle": "Discover Felta Point, offering convenient apartments near 16th Street Station in Sacramento County. Enjoy seamless transit and exceptional amenities.",
      "page_copy": "Nestled within the vibrant locale near 16th Street Station, Felta Point offers residents the perfect blend of convenience and comfort in Sacramento County. Our nearby apartments provide ideal access to the bustling heart of Sacramento, ensuring that work, play, and exploration are always within easy reach.\n\nAt Felta Point, we prioritize lifestyle with amenities designed to enhance your daily living. Residents can stay active with our fitness center, enjoy free Wi-Fi, or unwind at one of the two sparkling swimming pools. Whether you're hitting shots on the tennis court or making use of the centralized heating and air conditioning in our modern apartments, Felta Point ensures a stress-free lifestyle. Experience the best of Sacramento County living, mere moments from the 16th Street Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 16th Street Station, Sacramento",
      "seo_description": "Live at Felta Point, near 16th Street Station, Sacramento County. Top amenities and convenient transit access await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5974"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372413818"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NC3TW3B6"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55019388819"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-625-2560 "
    }
  ],
  "custom_qb_id": "5974",
  "custom_repli_id": "18372413818",
  "custom_google_gtm_id": "GTM-NC3TW3B6",
  "custom_hubspot_company_id": "55019388819",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-625-2560 "
};

export const generatedAt = '2026-09-23T19:56:39.009Z';
